// assets/nd-export.js — PDF v4.3L + QuotationNo sync (GAS preferred, fallback DRAFT)
// RIGHT 區塊貼圖：與「Door Size」齊平；Unit/Line 置中＆欄寬微調；
// 取圖用「目標 pt→像素」(含 Overscale)；Transom + 三扇(DXX-XXX/DGP-SLS) + 四扇(DXX-XXXX/DGP-SPLS) 皆可額外加寬/加高；
// ★ 每個 line 的可用高度上/下界，放不下時自動換到下一頁；
// ★ Quotation # 與檔名：優先使用 GAS 回傳的正式編號（ND_QUOTE_SERIAL_FULL / ND_LAST_FINAL_QUOTE），
//   若尚未產生正式編號，仍允許匯出，改用 DRAFT-日期 樣式。
// ★ v4.3L-FactorPerUnit: Line/Total 改成「單價*factor→round(cents)→*qty→加總」（per-unit rounding）
// ★ PATCH: Hide internal props (uuid/_bss/_nd/nd:) from PDF export (DOM/options/properties)
(function () {
  if (window.__ND_EXPORT_V43L_FLOW_BOUND_NEXT_PAGE__) return;
  window.__ND_EXPORT_V43L_FLOW_BOUND_NEXT_PAGE__ = true;

  /* ------------ CLOUD CONFIG ------------ */
  const CLOUD_UPLOAD_ENABLED = true;
  const CLOUD_ENDPOINT = 'https://nd-onedrive-uploader-2.vercel.app/apps/nd-upload/upload';
  const ROOT_FOLDER = 'QuoteNeuma';

  /* ------------ IMAGE LAYOUT（可調） ------------ */
  const IMG_SCALE = 0.9;                     // 全局放大倍率
  const BASE_LAND_W = 45, BASE_LAND_H = 38;  // 橫圖基準尺寸（pt）
  const BASE_PORT_W = 32, BASE_PORT_H = 64;  // 直圖基準尺寸（pt）

  const RCOL_PAD = 8;                        // 右欄內距
  const RCOL_GAP_Y = 6;                      // 兩張圖的垂直間距
  const MAX_IMAGES_PER_ITEM = 2;             // 每品項最多幾張
  const RCOL_TOP_GUARD = 26;                 // 與主列金額的最小距離
  const ANCHOR_EXTRA_Y = 6;                  // 對齊 Door Size 後再往下推
  const RCOL_SHRINK_W = 4;                   // 右欄可用寬再縮一點，避免貼右邊

  // Transom (DGT-) bonus（pt）
  const TRANSOM_W_BONUS = 22;
  const TRANSOM_H_BONUS = -15;
  const TRANSOM_EXTRA_DOWN = 6;

  // 三扇/四扇 bonus（pt）
  const P3_W_BONUS = 20, P3_H_BONUS = 25;    // DXX-XXX、DGP-SLS
  const P4_W_BONUS = 26, P4_H_BONUS = 20;    // DXX-XXXX、DGP-SPLS

  // 提高清晰度：重取圖時多抓像素（再縮回來畫）
  const FETCH_OVERSCALE = 1.6;               // 1.0~2.0 越大越清晰（檔案也較大）

  // 圖片順序：'swap2' | 'reverse' | 'keep'
  const IMG_ORDER = 'swap2';
  function reorderImages(arr) {
    const a = Array.isArray(arr) ? arr.slice() : [];
    if (IMG_ORDER === 'swap2' && a.length >= 2) {
      const t = a[0]; a[0] = a[1]; a[1] = t;
    } else if (IMG_ORDER === 'reverse') {
      a.reverse();
    }
    return a;
  }

  // 名稱偵測
  const isTransomUrl = (u) => (/(?:^|\/)DGT-[A-Za-z0-9_-]+/i).test(String(u || ''));
  const isThreePanel = (u) =>
    (/(?:^|\/)D[A-Za-z0-9]{2}-[A-Za-z0-9]{3}(?=[._-]|$)/i).test(String(u || '')) ||
    (/(?:^|\/)DGP-SLS(?=[._-]|$)/i).test(String(u || ''));
  const isFourPanel = (u) =>
    (/(?:^|\/)D[A-Za-z0-9]{2}-[A-Za-z0-9]{4}(?=[._-]|$)/i).test(String(u || '')) ||
    (/(?:^|\/)DGP-SPLS(?=[._-]|$)/i).test(String(u || ''));

  // 1pt ≈ 1.333px（以 96DPI 算）
  const ptToPx = (pt) => Math.max(64, Math.round(pt * 1.3333));

  /* ------------ utils ------------ */
  const norm = s => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const pad2 = n => String(n).padStart(2, '0');
  const fmtMDY = (d = new Date()) => `${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}-${d.getFullYear()}`;

  // ★ disclaimer：Config vs quotation
  const DISCLAIMER_TEXT =
    'Please Note : ';

  // ★ 會計式金額格式（3 位一逗點，保留兩位小數）
  function fmtMoney(val) {
    const num = Number(val || 0);
    const fixed = num.toFixed(2);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  // cents → "$x,xxx.xx"
  const money2 = c => fmtMoney(Number(c || 0) / 100);

  function j(id, fallback) {
    try {
      const el = document.getElementById(id);
      return el ? (JSON.parse(el.textContent || el.innerText || 'null') ?? fallback) : fallback;
    } catch (_) { return fallback; }
  }

  const CUST = j('cx2-customer-json', { id: null, email: null, tags: [] });
  const TAGS = j('cx2-tags-json', []);
  const customerEmail = (CUST?.email || 'guest').toLowerCase();

  // ★ 優先用 GAS 回傳的正式 quotation_no：
  //   1) ND_QUOTE_SERIAL_FULL（nd-quote-final.js 存的）
  //   2) ND_LAST_FINAL_QUOTE.quotation_no
  //   3) 舊版 ND_QUOTE_FINAL_INFO.quotation_no
  function getOfficialQuoteNo() {
    try {
      if (window.ND_QUOTE_SERIAL_FULL) {
        const q1 = String(window.ND_QUOTE_SERIAL_FULL).trim().toUpperCase();
        if (/^[A-Z0-9]{6}-\d{5}$/.test(q1)) return q1;
      }
      const info = window.ND_LAST_FINAL_QUOTE || window.ND_QUOTE_FINAL_INFO || null;
      if (!info || !info.quotation_no) return null;
      const q = String(info.quotation_no).trim().toUpperCase();
      if (!/^[A-Z0-9]{6}-\d{5}$/.test(q)) return null;
      return q;
    } catch (e) {
      return null;
    }
  }

  // 以下 localStorage 跑號工具，保留但不再用來命名檔案（只當備援資訊）
  function prefixFromTags() {
    const hit = Array.isArray(TAGS) ? TAGS.find(t => /^[A-Za-z0-9]{6}$/.test(String(t).trim())) : null;
    return hit ? String(hit).toUpperCase() : 'GUEST';
  }
  function customerKey() { return CUST?.id || CUST?.email || 'anon'; }
  const SERIAL_PAD = 5;
  const SKEY = p => `ND:SERIAL2:${customerKey()}:${p}`;
  function getState(p) {
    try { return JSON.parse(localStorage.getItem(SKEY(p)) || 'null') || null; }
    catch (_) { return null; }
  }
  function putState(p, st) { localStorage.setItem(SKEY(p), JSON.stringify(st)); }
  function currentSerial(p) {
    let st = getState(p);
    if (!st || st.prefix !== p) {
      st = { n: 1, pdf: false, xlsx: false, prefix: p };
      putState(p, st);
    }
    return `${p}-${String(st.n).padStart(SERIAL_PAD, '0')}`;
  }
  function done(which) {
    const p = prefixFromTags();
    let st = getState(p) || { n: 1, pdf: false, xlsx: false, prefix: p };
    if (which === 'pdf') st.pdf = true;
    if (which === 'xlsx') st.xlsx = true;
    st.n++;
    putState(p, st);
    return `${p}-${String(st.n).padStart(SERIAL_PAD, '0')}`;
  }
  const markPdfDone = () => done('pdf'); // 現在幾乎不會用到，只是保留

  async function fetchCart() {
    const r = await fetch('/cart.js?_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    });
    if (!r.ok) throw new Error('Failed to load /cart.js');
    return r.json();
  }

  async function uploadToCloud(fileBlob, filename, subpath, meta = {}) {
    if (!CLOUD_UPLOAD_ENABLED || !fileBlob) return { ok: true, skipped: true };
    const fileObj = (fileBlob instanceof File)
      ? fileBlob
      : new File([fileBlob], filename, { type: (fileBlob.type || 'application/pdf') });

    const fd = new FormData();
    fd.append('file', fileObj, fileObj.name);
    fd.append('path', subpath);
    fd.append('subpath', subpath);
    fd.append('filename', filename);
    fd.append('customer', customerEmail);
    if (meta.serial) fd.append('serial', meta.serial);
    if (meta.reference) fd.append('reference', meta.reference);

    const resp = await fetch(CLOUD_ENDPOINT, { method: 'POST', body: fd });
    if (!resp.ok) {
      let t = ''; try { t = await resp.text(); } catch (_) { }
      throw new Error(`Upload failed (${resp.status}) ${t.slice(0, 120)}`);
    }
    try { return await resp.json(); } catch (_) { return { ok: true }; }
  }

  function domRows() {
    return Array.from(document.querySelectorAll('#main-cart-items tbody tr.cart-item'));
  }
  function readPairs(tr) {
    const nodes = tr?.querySelectorAll('.product-option') || [];
    const out = [];
    nodes.forEach(n => {
      const k = n.querySelector('dt')?.textContent?.replace(/:\s*$/, '').trim() || '';
      const v = n.querySelector('dd')?.textContent?.trim() || '';
      if (!k) return;
      if (k.startsWith('_') || /^_+bss/i.test(k)) return;
      out.push([k, v]);
    });
    return out;
  }


  /* ------------ PREMIUM SUPPORT ------------ */
  function detectSeriesByItemRow(item, tr) {
    const title = String(
      item?.product_title ||
      item?.title ||
      tr?.querySelector('.cart-item__name')?.textContent ||
      tr?.querySelector('.cart-item__details a')?.textContent ||
      ''
    ).trim().toLowerCase();

    if (/\bpremium\b/.test(title)) return 'premium';
    return 'royal';
  }

  function getRowTextSafe(tr) {
    return String(tr?.innerText || tr?.textContent || '')
      .replace(/\r/g, '\n')
      .replace(/\n{2,}/g, '\n')
      .trim();
  }

  function getPremiumSummaryText(tr, item) {
    const rowText = getRowTextSafe(tr);
    const lines = rowText
      .split(/\n+/)
      .map(s => String(s || '').trim())
      .filter(Boolean);

    for (const line of lines) {
  let m = line.match(/^Door\s*Unit\s*:\s*(.+)$/i);
  if (m && m[1]) return m[1].trim();

  m = line.match(/^Config\s*:\s*(.+)$/i);
  if (m && m[1]) return m[1].trim();
}

    const title = String(
      item?.product_title ||
      item?.title ||
      tr?.querySelector('.cart-item__name')?.textContent ||
      ''
    ).trim();

    const candidates = lines.filter(line => {
      if (!line) return false;
      if (title && line === title) return false;
      if (/^\$?[\d,]+(?:\.\d{2})?(?:\s*usd)?$/i.test(line)) return false;
      if (/^quantity$/i.test(line)) return false;
      if (/^total$/i.test(line)) return false;
      if (/^product$/i.test(line)) return false;
      if (/^[\-\+]$/.test(line)) return false;
      if (/^\d+$/.test(line)) return false;
      return true;
    });

    candidates.sort((a, b) => b.length - a.length);
    return candidates[0] || '';
  }

  function premiumTitleCase(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\b\w+/g, w => w.charAt(0).toUpperCase() + w.slice(1));
  }

  function premiumPrettyValue(s) {
    let v = String(s || '').trim();
    if (!v) return '';
    v = v.replace(/\bRH\b/ig, 'RH');
    v = v.replace(/\bLH\b/ig, 'LH');
    v = v.replace(/\bXO\b/ig, 'XO');
    v = v.replace(/\bOX\b/ig, 'OX');
    v = v.replace(/\bNO\s+SDL\b/ig, 'No SDL');
    v = v.replace(/\bNO\s+GBG\b/ig, 'No GBG');
    v = v.replace(/\bWITH\s+SDL\b/ig, 'With SDL');
    v = v.replace(/\bWITH\s+GBG\b/ig, 'With GBG');
    v = v.replace(/\bWITHOUT\s+PET\s+DOOR\b/ig, 'Without Pet Door');
    v = v.replace(/\bWITH\s+PET\s+DOOR\b/ig, 'With Pet Door');
    v = v.replace(/\bFULL\s*LITE\b/ig, 'Full Lite');
    v = v.replace(/\bFULL\s*VIEW\b/ig, 'Full View');
    v = v.replace(/\b3\s*\/\s*4\s*LITE\b/ig, '3/4 Lite');
    v = v.replace(/\bCLEAR\s+BLINDS\b/ig, 'Clear Blinds');
    v = v.replace(/\bSTANDARD\b/ig, 'Standard');
    v = v.replace(/\bTYPE\s*(\d+)\b/ig, 'Type $1');
    v = v.replace(/\bDP\s*-?\s*(\d+)\b/ig, 'DP-$1');
    return premiumTitleCase(v)
      .replace(/\bRh\b/g, 'RH')
      .replace(/\bLh\b/g, 'LH')
      .replace(/\bXo\b/g, 'XO')
      .replace(/\bOx\b/g, 'OX')
      .replace(/\bDp-(\d+)\b/g, 'DP-$1')
      .replace(/\bSdl\b/g, 'SDL')
      .replace(/\bGbg\b/g, 'GBG');
  }

  function premiumConsumeUntil(tokens, startIdx, stopFn) {
    const out = [];
    let i = startIdx;
    while (i < tokens.length && !stopFn(tokens[i], i)) {
      out.push(tokens[i]);
      i++;
    }
    return { value: out.join('-').trim(), next: i };
  }

  function parsePremiumSummary(summary) {
    const raw = String(summary || '')
  .replace(/^Door\s*Unit\s*:\s*/i, '')
  .replace(/^Config\s*:\s*/i, '')
  .replace(/\s+/g, ' ')
  .trim();

    if (!raw) return [];

    const tokens = raw.split('-').map(s => String(s || '').trim()).filter(Boolean);
    if (!tokens.length) return [{ label: 'Configuration', value: raw }];

    const details = [];
    let i = 0;

    const first = tokens[i] || '';
    if (/^\d{4,6}$/.test(first)) {
      details.push({ label: 'Size', value: first });
      i++;
    }

    const handing = tokens[i] || '';
    if (/^(RH|LH|XO|OX|XXO|OXX)$/i.test(handing)) {
      details.push({ label: 'Handing', value: handing.toUpperCase() });
      i++;
    }

    const panel = tokens[i] || '';
    if (/^(full\s*lite|full\s*view|3\s*\/\s*4\s*lite|three\s*quarter\s*lite)$/i.test(panel)) {
      details.push({ label: 'Panel Type', value: premiumPrettyValue(panel) });
      i++;
    }

    const glass = tokens[i] || '';
    if (/(clear|frost|obscure|glass|loe|low\s*e|blinds|tempered|laminated)/i.test(glass)) {
      details.push({ label: 'Glass', value: premiumPrettyValue(glass) });
      i++;
    }

    const stopFinish = (tok) => /^(dp|\d+|dp\s*-?\s*\d+|no\s+sdl|with\s+sdl|no\s+gbg|with\s+gbg|standard|type\s*\d+|with\s+pet\s+door|without\s+pet\s+door)$/i.test(tok);
    const fin = premiumConsumeUntil(tokens, i, stopFinish);
    if (fin.value) {
      details.push({ label: 'Finish', value: premiumPrettyValue(fin.value.replace(/\s+and\s+/ig, ' / ')) });
      i = fin.next;
    }

    if (i < tokens.length) {
      const t = tokens[i] || '';
      if (/^dp$/i.test(t) && /^\d+$/.test(tokens[i + 1] || '')) {
        details.push({ label: 'DP Rating', value: `DP-${tokens[i + 1]}` });
        i += 2;
      } else if (/^dp\s*-?\s*\d+$/i.test(t)) {
        const m = t.match(/(\d+)/);
        details.push({ label: 'DP Rating', value: m ? `DP-${m[1]}` : premiumPrettyValue(t) });
        i += 1;
      }
    }

    if (i < tokens.length && /^(no\s+sdl|with\s+sdl)$/i.test(tokens[i])) {
      details.push({ label: 'SDL', value: premiumPrettyValue(tokens[i]) });
      i++;
    }

    if (i < tokens.length && /^(no\s+gbg|with\s+gbg)$/i.test(tokens[i])) {
      details.push({ label: 'GBG', value: premiumPrettyValue(tokens[i]) });
      i++;
    }

    if (i < tokens.length && /^standard$/i.test(tokens[i])) {
      details.push({ label: 'Lock Type', value: premiumPrettyValue(tokens[i]) });
      i++;
    }

    if (i < tokens.length && /^type\s*\d+/i.test(tokens[i])) {
      details.push({ label: 'Hardware', value: premiumPrettyValue(tokens[i]) });
      i++;
    }

    if (i < tokens.length && /pet\s+door/i.test(tokens[i])) {
      details.push({ label: 'Pet Door', value: premiumPrettyValue(tokens[i]) });
      i++;
    }

    const remainder = tokens.slice(i).join('-').trim();
    if (remainder) {
      details.push({ label: 'Configuration', value: premiumPrettyValue(remainder) });
    }

    return details.filter(x => x && x.label && x.value);
  }

  function buildPremiumDetailRows(summary, seen) {
    const rows = [];
    const parsed = parsePremiumSummary(summary);
    parsed.forEach(({ label, value }) => {
      const key = `${norm(label)}|${norm(value)}`;
      if (seen.has(key)) return;
      seen.add(key);
      rows.push(['', `· ${label}`, value, '', '', '', '']);
    });
    return rows;
  }

  function readDimensionBlockFromCartRow(tr) {
  try {
    if (!tr) return { unitDim: '', roughOpening: '', glassDimension: '' };

    const text = tr.innerText || tr.textContent || '';
    if (!text) return { unitDim: '', roughOpening: '', glassDimension: '' };

    function pick(label) {
      const re = new RegExp(label + '\\s*:\\s*([^\\n\\r]+)', 'i');
      const m = text.match(re);
      return m ? String(m[1] || '').trim() : '';
    }

    return {
      unitDim: pick('Unit\\s*Dim\\.?'),
      roughOpening: pick('Rough\\s*Opening'),
      glassDimension: pick('Glass\\s*Dimension')
    };
  } catch (e) {
    console.warn('[ND PDF] readDimensionBlockFromCartRow failed', e);
    return { unitDim: '', roughOpening: '', glassDimension: '' };
  }
}

  function parseAddon(raw) {
    if (raw == null) return { clean: '', add: '' };
    let s = String(raw).trim();
    const re = /\(\s*\+\s*\$?\s*([0-9,]+(?:\.\d{1,2})?)\s*\)\s*$/g;
    let m, tot = 0;
    while ((m = re.exec(s)) !== null) {
      tot += parseFloat(m[1].replace(/,/g, '')) || 0;
    }
    s = s.replace(re, '').replace(/\s{2,}/g, ' ').trim();
    return { clean: s, add: tot ? tot.toFixed(2) : '' };
  }

  function buildDoorTypeCategoryMapForNoGlass() {
  const out = {};
  const map = window.NO_GLASS_DEDUCTION_MAP || {};

  Object.keys(map).forEach(category => {
    const categoryMap = map[category] || {};
    Object.keys(categoryMap).forEach(doorType => {
      out[doorType] = category;
    });
  });

  return out;
}

function getCategoryByDoorTypeForNoGlass(doorType) {
  return buildDoorTypeCategoryMapForNoGlass()[doorType] || '';
}

function normalizePanelTypeForNoGlass(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
    return 'three_quarter_lite';
  }
  if (/full\s*view|full\s*lite/.test(text)) {
    return 'full_lite';
  }
  return '';
}

function normalizeDoorSizeForNoGlass(raw) {
  const m = String(raw || '').match(/\b\d{4,6}\b/);
  return m ? m[0] : '';
}

function normalizeDoorTypeForNoGlass(raw) {
  const text = String(raw || '').toLowerCase().trim();

  // 先支援直接 doorType 值
  if (getCategoryByDoorTypeForNoGlass(text)) return text;

  // hinged
  if (/single[\s_-]*hinged/.test(text)) return 'single_hinged';
  if (/double[\s_-]*hinged/.test(text)) return 'double_hinged';
  if (/center[\s_-]*hinged/.test(text)) return 'center_hinged';
  if (/vented[\s_-]*sidelight|venting[\s_-]*sidelight/.test(text)) return 'vented_sidelight';

  // new hinged
  if (/folding\s*door|folding[\s_-]*door|^folding$/.test(text)) return 'folding';

  // gliding
  if (/gliding\s*door\s*-\s*2\s*panels|gliding[\s_-]*2[\s_-]*panel/.test(text)) return 'gliding_2_panel';
  if (/gliding\s*door\s*-\s*3\s*panels|gliding[\s_-]*3[\s_-]*panel/.test(text)) return 'gliding_3_panel';
  if (/gliding\s*door\s*-\s*4\s*panels|gliding[\s_-]*4[\s_-]*panel/.test(text)) return 'gliding_4_panel';

  // new gliding
  if (
    /bypass\s*gliding\s*door|bypass[\s_-]*gliding[\s_-]*door|gliding[\s_-]*bypass|bypass[\s_-]*gliding/.test(text)
  ) return 'gliding_bypass';

  // fixed
  if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return 'gliding_one_panel';
  if (/fixed\s*-\s*1\s*panel/.test(text)) return 'hinged_one_panel';
  if (/fixed\s*-\s*2\s*panels/.test(text)) return 'hinged_two_panel';
  if (/fixed\s*-\s*3\s*panels/.test(text)) return 'hinged_three_panel';

  return '';
}

function getTitleTextFromRowForNoGlass(tr) {
  if (!tr) return '';
  return (
    tr.querySelector('.cart-item__name')?.textContent ||
    tr.querySelector('.cart-item__details a')?.textContent ||
    tr.querySelector('.cart-item__details')?.textContent ||
    ''
  ).trim();
}

function getNoGlassDeductionCentsFromPairs(pairs, tr) {
  try {
    const map = window.NO_GLASS_DEDUCTION_MAP || {};

    let size = '';
    let panelType = '';
    let glassValue = '';
    let doorType = '';

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForNoGlass(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForNoGlass(vv);
      }

      if (!glassValue && /glass\s*option/i.test(kk)) {
        glassValue = vv;
      }

      if (!doorType && /door\s*type/i.test(kk)) {
        doorType = normalizeDoorTypeForNoGlass(vv);
      }
    });

    if (!doorType) {
      doorType = normalizeDoorTypeForNoGlass(getTitleTextFromRowForNoGlass(tr));
    }

    const category = getCategoryByDoorTypeForNoGlass(doorType);

    if (!/no\s*glass/i.test(String(glassValue || ''))) return 0;
    if (!category || !doorType || !size || !panelType) return 0;

    const dollars = Number(
      map?.[category]?.[doorType]?.[size]?.[panelType] || 0
    );

    if (window.NO_GLASS_DEBUG_MODE) {
      console.log('[ND PDF][NoGlass]', {
        title: getTitleTextFromRowForNoGlass(tr),
        category,
        doorType,
        size,
        panelType,
        glassValue,
        dollars
      });
    }

    return Math.round(dollars * 100);
  } catch (e) {
    console.warn('[ND PDF] no-glass deduction parse failed', e);
    return 0;
  }
}

function normalizePanelTypeForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
    return 'three_quarter_lite';
  }
  if (/full\s*view|full\s*lite/.test(text)) {
    return 'full_lite';
  }
  return '';
}

function normalizeDoorSizeForUnitDim(raw) {
  const m = String(raw || '').match(/\b\d{4,6}\b/);
  return m ? m[0] : '';
}

function normalizeSwingForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/out\s*swing|outswing/.test(text)) return 'outswing';
  if (/in\s*swing|inswing/.test(text)) return 'inswing';
  return 'all';
}

function normalizeDoorTypeForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();

  if (/single[\s_-]*hinged/.test(text)) return { group: 'hinged', style: 'single_hinged' };
  if (/double[\s_-]*hinged/.test(text)) return { group: 'hinged', style: 'double_hinged' };
  if (/vented[\s_-]*sidelight|venting[\s_-]*sidelight/.test(text)) {
    return { group: 'hinged', style: 'vented_sidelight' };
  }
  if (/center[\s_-]*hinged.*2\s*panels?|center[\s_-]*hinged.*2\s*panel/.test(text)) {
    return { group: 'hinged', style: 'center_hinged_2_panel' };
  }
  if (/center[\s_-]*hinged.*3\s*panels?|center[\s_-]*hinged.*3\s*panel/.test(text)) {
    return { group: 'hinged', style: 'center_hinged_3_panel' };
  }

  if (/bypass\s*gliding/.test(text)) return { group: 'gliding', style: 'bypass_gliding' };
  if (/gliding\s*door.*2\s*panels?|gliding.*2\s*panel/.test(text)) return { group: 'gliding', style: 'gliding_2_panel' };
  if (/gliding\s*door.*3\s*panels?|gliding.*3\s*panel/.test(text)) return { group: 'gliding', style: 'gliding_3_panel' };
  if (/gliding\s*door.*4\s*panels?|gliding.*4\s*panel/.test(text)) return { group: 'gliding', style: 'gliding_4_panel' };

  if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return { group: 'fixed', style: 'gliding_one_panel' };
  if (/fixed\s*-\s*1\s*panel/.test(text)) return { group: 'fixed', style: 'hinged_one_panel' };
  if (/fixed\s*-\s*2\s*panels?/.test(text)) return { group: 'fixed', style: 'hinged_two_panel' };
  if (/fixed\s*-\s*3\s*panels?/.test(text)) return { group: 'fixed', style: 'hinged_three_panel' };

  if (/transom\s*-\s*1\s*lite/.test(text)) return { group: 'transom', style: 'transom_1_lite' };
  if (/transom\s*-\s*2\s*lite/.test(text)) return { group: 'transom', style: 'transom_2_lite' };
  if (/transom\s*-\s*3\s*lite/.test(text)) return { group: 'transom', style: 'transom_3_lite' };
  if (/transom\s*-\s*4\s*lite/.test(text)) return { group: 'transom', style: 'transom_4_lite' };

  return { group: '', style: '' };
}

function getTitleTextFromRowForUnitDim(tr, item) {
  if (tr) {
    const t =
      tr.querySelector('.cart-item__name')?.textContent ||
      tr.querySelector('.cart-item__details a')?.textContent ||
      tr.querySelector('.cart-item__details')?.textContent ||
      '';
    if (String(t || '').trim()) return String(t).trim();
  }
  return String(item?.product_title || item?.title || '').trim();
}

function getUnitDimensionFromPairs(pairs, tr, item) {
  try {
    const map = window.UNIT_DIMENSION_MAP || {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    function pickString(node) {
      if (!node) return '';

      if (typeof node === 'string') return node;

      if (typeof node !== 'object') return '';

      if (swing && typeof node[swing] === 'string') return node[swing];
      if (typeof node.all === 'string') return node.all;

      const keys = Object.keys(node);
      for (const key of keys) {
        const val = pickString(node[key]);
        if (val) return val;
      }

      return '';
    }

    // 先走 panelType
    if (panelType && sizeNode[panelType]) {
      return pickString(sizeNode[panelType]);
    }

    // 再直接從 sizeNode 往下找字串
    return pickString(sizeNode);
  } catch (e) {
    console.warn('[ND PDF] getUnitDimensionFromPairs failed', e);
    return '';
  }
}
function getRoughOpeningFromPairs(pairs, tr, item) {
  try {
    const map =
      window.ROUGH_OPENING_MAP ||
      window.ROUGH_OPENING_DIMENSION_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    function pickString(node) {
      if (!node) return '';
      if (typeof node === 'string') return node;
      if (typeof node !== 'object') return '';

      if (swing && typeof node[swing] === 'string') return node[swing];
      if (typeof node.all === 'string') return node.all;

      const keys = Object.keys(node);
      for (const key of keys) {
        const val = pickString(node[key]);
        if (val) return val;
      }
      return '';
    }

    if (panelType && sizeNode[panelType]) {
      return pickString(sizeNode[panelType]);
    }

    return pickString(sizeNode);
  } catch (e) {
    console.warn('[ND PDF] getRoughOpeningFromPairs failed', e);
    return '';
  }
}

function getGlassDimensionFromPairs(pairs, tr, item) {
  try {
    const map =
      window.GLASS_DIMENSION_MAP ||
      window.GLASS_DIM_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    function pickString(node) {
      if (!node) return '';
      if (typeof node === 'string') return node;
      if (typeof node !== 'object') return '';

      if (swing && typeof node[swing] === 'string') return node[swing];
      if (typeof node.all === 'string') return node.all;

      const keys = Object.keys(node);
      for (const key of keys) {
        const val = pickString(node[key]);
        if (val) return val;
      }
      return '';
    }

    if (panelType && sizeNode[panelType]) {
      return pickString(sizeNode[panelType]);
    }

    return pickString(sizeNode);
  } catch (e) {
    console.warn('[ND PDF] getGlassDimensionFromPairs failed', e);
    return '';
  }
}

function getRoughOpeningFromPairs(pairs, tr, item) {
  try {
    const map =
      window.ROUGH_OPENING_MAP ||
      window.ROUGH_OPENING_DIMENSION_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    if (typeof sizeNode === 'string') return sizeNode;

    if (panelType && sizeNode[panelType]) {
      const panelNode = sizeNode[panelType];
      return panelNode?.[swing || 'all'] || panelNode?.all || '';
    }

    if (sizeNode[swing || 'all'] || sizeNode.all) {
      return sizeNode[swing || 'all'] || sizeNode.all || '';
    }

    const keys = Object.keys(sizeNode || {});
    if (keys.length === 1) {
      const onlyNode = sizeNode[keys[0]];
      if (typeof onlyNode === 'string') return onlyNode;
      return onlyNode?.[swing || 'all'] || onlyNode?.all || '';
    }

    return '';
  } catch (e) {
    console.warn('[ND PDF] getRoughOpeningFromPairs failed', e);
    return '';
  }
}

function getGlassDimensionFromPairs(pairs, tr, item) {
  try {
    const map =
      window.GLASS_DIMENSION_MAP ||
      window.GLASS_DIM_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    if (typeof sizeNode === 'string') return sizeNode;

    if (panelType && sizeNode[panelType]) {
      const panelNode = sizeNode[panelType];
      return panelNode?.[swing || 'all'] || panelNode?.all || '';
    }

    if (sizeNode[swing || 'all'] || sizeNode.all) {
      return sizeNode[swing || 'all'] || sizeNode.all || '';
    }

    const keys = Object.keys(sizeNode || {});
    if (keys.length === 1) {
      const onlyNode = sizeNode[keys[0]];
      if (typeof onlyNode === 'string') return onlyNode;
      return onlyNode?.[swing || 'all'] || onlyNode?.all || '';
    }

    return '';
  } catch (e) {
    console.warn('[ND PDF] getGlassDimensionFromPairs failed', e);
    return '';
  }
}

  // ★★ 只針對「上方 Reference Number」
  function readReferenceFallbackFromDOM() {
    const sels = [
      'input[name="attributes[Reference Number]"]',
      'input[name="attributes[reference_number]"]',
      '#Cart-reference-number',
      'input#Cart-reference-number',
      '[data-ref-number]'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el && typeof el.value === 'string') {
        const v = el.value.trim();
        if (v) return v;
      }
    }
    return '';
  }

  // Special Instruction（下面的 note）
  function readSpecialInstructionFromDOM() {
    const sels = [
      '#Cart-note',
      'textarea#Cart-note',
      'textarea[name="note"]',
      'textarea[name="attributes[Special Instruction]"]',
      'textarea[name="attributes[special_instruction]"]',
      '[data-special-instruction]'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el && typeof el.value === 'string') {
        const v = el.value.trim();
        if (v) return v;
      }
    }
    return '';
  }

  const DELIVERY_METHOD_STORAGE_KEY =
    'MPQ_DELIVERY_METHOD_V1';

  function readDeliveryMethodLabel(cart) {
    const attrs = (cart && cart.attributes) || {};
    const cartValue = String(
      attrs['Delivery Method'] || ''
    ).trim();

    if (
      cartValue === 'Customer Pickup' ||
      cartValue === 'Customer-Arranged Carrier'
    ) {
      return cartValue;
    }

    try {
      const stored = String(
        localStorage.getItem(
          DELIVERY_METHOD_STORAGE_KEY
        ) || ''
      ).trim();

      if (stored === 'CUSTOMER_PICKUP') {
        return 'Customer Pickup';
      }

      if (stored === 'CUSTOMER_CARRIER') {
        return 'Customer-Arranged Carrier';
      }
    } catch (_) {}

    return '';
  }

function readAmountDiscountFromDOM() {
  const text = document.body.innerText || '';

  let m = text.match(/volume\s*discount\s*\(\s*-\$?\s*([\d,]+(?:\.\d{2})?)\s*\)/i);
  if (m) return Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);

  m = text.match(/volume\s*discount[^\d-]*-\$?\s*([\d,]+(?:\.\d{2})?)/i);
  if (m) return Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);

  m = text.match(/discount\s*\(\s*-\$?\s*([\d,]+(?:\.\d{2})?)\s*\)/i);
  if (m) return Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);

  m = text.match(/discount[^\d-]*-\$?\s*([\d,]+(?:\.\d{2})?)/i);
  if (m) return Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);

  return 0;
}

  // 上方運送資訊
  function readShippingInfoFromDOM() {
    function val(selectors) {
      for (const sel of selectors) {
        const el = document.querySelector(sel);
        if (el && typeof el.value === 'string') {
          const v = el.value.trim();
          if (v) return v;
        }
      }
      return '';
    }
    const contact = val([
      'input[name="attributes[Shipping Contact Name]"]',
      'input[name="attributes[Contact Name]"]',
      'input[name="attributes[contact_name]"]',
      '[data-nd-contact]'
    ]);
    const phone = val([
      'input[name="attributes[Shipping Phone]"]',
      'input[name="attributes[Phone Number]"]',
      'input[name="attributes[phone_number]"]',
      '[data-nd-phone]'
    ]);
    const company = val([
      'input[name="attributes[Company Name]"]',
      '[data-nd-company]'
    ]);
    const address = val([
  'textarea[name="attributes[Shipping Address]"]',
  'textarea[name="attributes[shipping_address]"]',
  '[data-nd-shipaddr]'
]);

const state = val([
  'select[name="attributes[Shipping State]"]',
  'input[name="attributes[Shipping State]"]',
  '[data-nd-shipstate]'
]);

return { contact, phone, company, address, state };
  }

  // fuzzy key match：把空白 / 底線拔掉再比對
  function pickAttr(attrs, domVal, candidates) {
    if (domVal && String(domVal).trim()) return String(domVal).trim();
    const normKey = k => String(k || '').toLowerCase().replace(/[\s_]+/g, '');
    const wants = (candidates || []).map(normKey);
    const keys = Object.keys(attrs || {});
    for (const k of keys) {
      const nk = normKey(k);
      if (wants.includes(nk)) {
        const v = attrs[k];
        if (typeof v === 'string' && v.trim()) return v.trim();
      }
    }
    return '';
  }

  async function ensurePdfLibs() {
    if (!window.jspdf) {
      await new Promise((res, rej) => {
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
        s.onload = res; s.onerror = () => rej(new Error('jsPDF 載入失敗'));
        document.head.appendChild(s);
      });
    }
    if (!window.jspdf?.autoTable) {
      await new Promise((res, rej) => {
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/jspdf-autotable@3.8.2/dist/jspdf.plugin.autotable.min.js';
        s.onload = res; s.onerror = () => rej(new Error('autoTable 載入失敗'));
        document.head.appendChild(s);
      });
    }
  }
async function urlToDataUrl(url) {
  const resp = await fetch(url, { mode: 'cors', cache: 'no-cache' });
  if (!resp.ok) throw new Error('logo fetch failed');

  const blob = await resp.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

  const FACTOR_KEY = 'cart_discount_factor_v1';
  function sanitizeDecimal(str) {
    str = String(str || '').replace(/[^0-9.]/g, '');
    const parts = str.split('.');
    if (parts.length > 2) str = parts.shift() + '.' + parts.join('');
    if (str.startsWith('.')) str = '0' + str;
    return str;
  }
  function clamp3(n) {
    n = Math.max(0, Math.min(9.999, Number(n)));
    return Number(n.toFixed(3));
  }
  function readLiveFactor() {
    const el = document.querySelector('#nd-factor-input,[name="nd-factor"],input[data-nd-factor],input[name="attributes[factor]"]');
    if (el && typeof el.value === 'string') {
      const raw = sanitizeDecimal(el.value);
      if (raw === '') {
        try { localStorage.removeItem(FACTOR_KEY); } catch (_) { }
        return 1.000;
      }
      const n = parseFloat(raw);
      return Number.isFinite(n) ? clamp3(n) : 1.000;
    }
    const ls = parseFloat(localStorage.getItem(FACTOR_KEY));
    return Number.isFinite(ls) ? clamp3(ls) : 1.000;
  }

  /* ---------- NEW: 只修「選配名稱」的 dash 後段，不影響值與其他結構 ---------- */
  const trimDashName = (s) => s == null ? s : String(s).replace(/\s-\s.*$/, '').trim();

  // ---- ND PDF export: hide internal properties (uuid/_bss/_nd/etc) ----
  function __ndNormalizeKey(k){
    return String(k || '').trim().toLowerCase();
  }
  function __ndShouldSkipExportPropKey(k){
    var kk = __ndNormalizeKey(k);

    // exact
    if (kk === 'uuid') return true;

    // bss/nd internals
    if (kk.indexOf('_bss') === 0) return true;
    if (kk.indexOf('bss_') === 0) return true;

    if (kk.indexOf('_nd') === 0) return true;
    if (kk.indexOf('nd_') === 0) return true;
    if (kk.indexOf('nd:') === 0) return true;

    // common markers used in reload/replace flows
    if (kk.indexOf('nd_reload') !== -1) return true;
    if (kk.indexOf('pending_replace') !== -1) return true;

    return false;
  }

  /* ---------- ND_EXPORT_SSOT fallback ---------- */
window.ND_EXPORT_SSOT = window.ND_EXPORT_SSOT || {
  calc({ options, factor, qty }) {
    const f = Number.isFinite(Number(factor)) ? Number(factor) : 1;
    const q = Number.isFinite(Number(qty)) ? Number(qty) : 0;

    let optionRawCents = 0;
    (options || []).forEach(opt => {
      optionRawCents += Number(opt?.rawCents || 0);
    });

    const unitAfterCents = Math.round(optionRawCents * f);
    const lineCents = unitAfterCents * q;

    return {
      optionRawCents,
      unitCents: unitAfterCents,
      lineCents
    };
  }
};

  // 🔓 expose to window for PDF + console test
 window.calcLineBySSOTFromDOM = function (tr, qty, factor) {
  const options = [];
  const pairs = [];

  if (tr) {
    tr.querySelectorAll('.product-option').forEach(node => {
      const name = node.querySelector('dt')?.textContent
        ?.replace(/:\s*$/, '')
        .trim();
      const rawVal = node.querySelector('dd')?.textContent?.trim();

      if (!name || !rawVal) return;

      const nk = name.toLowerCase();
      if (nk === 'uuid' || nk.startsWith('_')) return;
      if (__ndShouldSkipExportPropKey(name)) return;

      pairs.push([name, rawVal]);

      const p = parseAddon(rawVal);
      if (!p.add) return;

      options.push({
        name,
        value: p.clean,
        rawCents: Math.round(Number(p.add) * 100)
      });
    });
  }

  // No Glass deduction：依新 mapping 規則查表
  const noGlassDeductionCents = getNoGlassDeductionCentsFromPairs(pairs, tr);
  if (noGlassDeductionCents > 0) {
    options.push({
      name: 'No Glass Deduction',
      value: 'Deduction',
      rawCents: -noGlassDeductionCents
    });
  }

  return window.ND_EXPORT_SSOT.calc({
    options,
    factor,
    qty
  });
};

  /* ---------- ★ NEW: per-unit rounding 計算（你們系統要的） ---------- */
  function calcLineAfterFactorPerUnit(item, factor) {
    const qty = Number(item?.quantity || 0);
    const unitCents = Number(item?.final_price ?? item?.price ?? 0); // 單件 cents（含選配/折扣後）
    const unitAfterCents = Math.round(unitCents * factor);           // 單價先乘 factor → round 到 cents
    const lineAfterCents = unitAfterCents * qty;                     // 再乘 qty
    return { qty, unitCents, unitAfterCents, lineAfterCents };
  }
  function calcSubtotalAfterFactorPerUnit(cart, factor) {
    let sum = 0;
    for (const it of (cart?.items || [])) {
      const r = calcLineAfterFactorPerUnit(it, factor);
      if (r.qty) sum += r.lineAfterCents;
    }
    return sum;
  }

  /* ---------- 取圖（pt→px，含各型式加成） ---------- */
  function prioritizeUrls(list) {
    const arr = Array.from(new Set((list || []).filter(Boolean)));
    const key = /(need_drawing|_equal_lite|_4_lite_tall|_9_lite_prairie)/i;
    const score = (u) => (key.test(u) ? 300 : 0)
      + (/-FULL(\.|$)/i.test(u) ? 100 : 0)
      + (/(\.|-|_)34(\.|$)/i.test(u) ? 50 : 0);
    return arr.sort((a, b) => score(b) - score(a));
  }
  function panelBonus(u) {
    if (isFourPanel(u)) return { w: P4_W_BONUS, h: P4_H_BONUS };
    if (isThreePanel(u)) return { w: P3_W_BONUS, h: P3_H_BONUS };
    return { w: 0, h: 0 };
  }
  async function buildImageMap(cart, trs) {
  const map = {};
  const ND = window.NDIMG;

  function absUrl(u) {
    u = String(u || '').trim();
    if (!u) return '';
    if (u.startsWith('//')) return 'https:' + u;
    if (u.startsWith('/')) return window.location.origin + u;
    return u;
  }

  function pickFromSrcset(srcset) {
    const s = String(srcset || '').trim();
    if (!s) return '';
    const parts = s.split(',').map(x => x.trim()).filter(Boolean);
    if (!parts.length) return '';
    return parts[parts.length - 1].split(/\s+/)[0] || '';
  }

  function normalizeShopifyImgUrl(u, targetPx) {
    u = absUrl(u);
    if (!u) return '';

    // 避免抓到 80x80 / 120x120 的縮圖
    u = u.replace(/_(pico|icon|thumb|small|compact|medium|large|grande)(?=\.)/i, '');

    try {
      const url = new URL(u, window.location.origin);

      if (/cdn\.shopify\.com/i.test(url.hostname)) {
        url.searchParams.set('width', String(Math.max(600, targetPx || 900)));
      }

      return url.toString();
    } catch (_) {
      return u;
    }
  }

  function canonicalImageKey(u) {
  u = String(u || '').trim();
  if (!u) return '';

  if (u.startsWith('//')) u = 'https:' + u;
  if (u.startsWith('/')) u = window.location.origin + u;

  try {
    const url = new URL(u, window.location.origin);

    // Shopify 圖片常常只是 width / crop / v 不同，其實是同一張
    url.searchParams.delete('width');
    url.searchParams.delete('height');
    url.searchParams.delete('crop');
    url.searchParams.delete('v');

    let path = url.pathname;

    // 移除 Shopify 檔名尺寸，例如 _80x80、_120x、_master、_large
    path = path.replace(/_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.)/i, '');

    return url.hostname + path;
  } catch (_) {
    return u
      .replace(/\?.*$/, '')
      .replace(/_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.)/i, '');
  }
}

function uniqueImageUrls(urls) {
  const seen = new Set();
  const out = [];

  (urls || []).forEach(u => {
    u = String(u || '').trim();
    if (!u) return;

    const key = canonicalImageKey(u);
    if (!key || seen.has(key)) return;

    seen.add(key);
    out.push(u);
  });

  return out;
}


function isLikelyPdfDrawingSvg(svg) {
  if (!svg) return false;

  // 不限制 Royal / Premium，只認「這張圖是否要進 PDF」
  if (
    svg.matches(
      '[data-nd-pdf-drawing="1"], [data-nd-cart-drawing="1"], svg.nd-pdf-drawing, svg.nd-cart-drawing'
    ) ||
    svg.closest(
      '[data-nd-pdf-drawing="1"], [data-nd-cart-drawing="1"], .nd-pdf-drawing, .nd-cart-drawing'
    )
  ) {
    return true;
  }

  // 避免抓到 trash icon、qty button、一般操作 icon
  if (
    svg.closest('button') ||
    svg.closest('a') ||
    svg.closest('.quantity') ||
    svg.closest('.cart-remove-button') ||
    svg.closest('[class*="remove"]') ||
    svg.closest('[class*="trash"]')
  ) {
    return false;
  }

  // 備援：沒有標記時，只抓比較像產品圖的大 SVG
  const box = svg.getBoundingClientRect();
  return box.width >= 40 && box.height >= 40;
}

function copyComputedSvgStyles(srcRoot, dstRoot) {
  try {
    const srcNodes = [srcRoot, ...srcRoot.querySelectorAll('*')];
    const dstNodes = [dstRoot, ...dstRoot.querySelectorAll('*')];

    const props = [
      'fill',
      'stroke',
      'stroke-width',
      'stroke-linecap',
      'stroke-linejoin',
      'stroke-dasharray',
      'stroke-dashoffset',
      'opacity',
      'font-size',
      'font-family',
      'font-weight',
      'letter-spacing',
      'text-anchor',
      'dominant-baseline',
      'paint-order',
      'vector-effect'
    ];

    srcNodes.forEach((src, i) => {
      const dst = dstNodes[i];
      if (!dst) return;

      const cs = window.getComputedStyle(src);
      props.forEach(p => {
        const v = cs.getPropertyValue(p);
        if (v) dst.style.setProperty(p, v);
      });
    });
  } catch (e) {
    console.warn('[ND PDF] copy svg styles failed', e);
  }
}

async function svgToPngDataUrl(svg, targetPx) {
  try {
    const cloned = svg.cloneNode(true);

    copyComputedSvgStyles(svg, cloned);

    cloned.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    cloned.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    cloned.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    // ★ v7：真正解決「門被切到」
    // 不是 PDF 裡的尺寸問題，而是原始 SVG 有些門片/外開角度超出 viewBox。
    // 舊版直接照原 viewBox 轉 PNG，超出去的部分在轉圖時就已經被裁掉；
    // 後面再怎麼調 IMAGE_GLOBAL_SCALE 都救不回來。
    function readViewBox(el) {
      const vb = String(el.getAttribute('viewBox') || '').trim();
      const parts = vb.split(/[\s,]+/).map(Number).filter(Number.isFinite);
      if (parts.length === 4 && parts[2] > 0 && parts[3] > 0) {
        return { x: parts[0], y: parts[1], w: parts[2], h: parts[3] };
      }
      return null;
    }

    const vb0 = readViewBox(svg);
    let cap = vb0 ? { ...vb0 } : null;

    try {
      // getBBox 會抓到 SVG 內容實際幾何範圍；
      // 這可以包含超出原 viewBox 的門片、門框、把手、外開角度。
      const bb = svg.getBBox();
      if (bb && Number.isFinite(bb.x) && Number.isFinite(bb.y) && bb.width > 0 && bb.height > 0) {
        const pad = Math.max(8, Math.max(bb.width, bb.height) * 0.045);
        const bbCap = {
          x: bb.x - pad,
          y: bb.y - pad,
          w: bb.width + pad * 2,
          h: bb.height + pad * 2
        };

        if (cap) {
          const x1 = Math.min(cap.x, bbCap.x);
          const y1 = Math.min(cap.y, bbCap.y);
          const x2 = Math.max(cap.x + cap.w, bbCap.x + bbCap.w);
          const y2 = Math.max(cap.y + cap.h, bbCap.y + bbCap.h);
          cap = { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
        } else {
          cap = bbCap;
        }
      }
    } catch (e) {
      console.warn('[ND PDF] svg.getBBox failed, fallback to viewBox/client box:', e);
    }

    const box = svg.getBoundingClientRect();
    if (!cap) {
      const w0 = box.width || parseFloat(svg.getAttribute('width')) || 120;
      const h0 = box.height || parseFloat(svg.getAttribute('height')) || 120;
      cap = { x: 0, y: 0, w: Math.max(40, w0), h: Math.max(40, h0) };
    }

    cap.w = Math.max(40, cap.w);
    cap.h = Math.max(40, cap.h);

    // ★ 改寫 clone 的 viewBox，讓超出原 viewBox 的門片也被包含進 PNG。
    cloned.setAttribute('viewBox', `${cap.x} ${cap.y} ${cap.w} ${cap.h}`);

    const aspect = Math.max(0.2, cap.w / cap.h);
    const longSide = Math.max(700, Number(targetPx || 900));

    let outW, outH;
    if (aspect >= 1) {
      outW = longSide;
      outH = longSide / aspect;
    } else {
      outH = longSide;
      outW = longSide * aspect;
    }

    outW = Math.max(120, Math.ceil(outW));
    outH = Math.max(120, Math.ceil(outH));

    cloned.setAttribute('width', String(outW));
    cloned.setAttribute('height', String(outH));

    const svgText = new XMLSerializer().serializeToString(cloned);
    const blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
    const blobUrl = URL.createObjectURL(blob);

    const img = new Image();

    const dataUrl = await new Promise((resolve, reject) => {
      img.onload = () => {
        try {
          const renderScale = 2;
          const canvas = document.createElement('canvas');
          canvas.width = Math.ceil(outW * renderScale);
          canvas.height = Math.ceil(outH * renderScale);

          const ctx = canvas.getContext('2d');

          // 白底，避免 PDF 裡透明背景看起來髒或消失
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          resolve(canvas.toDataURL('image/png'));
        } catch (err) {
          reject(err);
        } finally {
          URL.revokeObjectURL(blobUrl);
        }
      };

      img.onerror = err => {
        URL.revokeObjectURL(blobUrl);
        reject(err);
      };

      img.src = blobUrl;
    });

    return {
      dataUrl,
      isLandscape: aspect >= 1,
      isPattern: false,
      isSvgDrawing: true,
      aspect,
      svgCaptureBox: cap,
      url: 'inline-svg-cart-drawing'
    };
  } catch (e) {
    console.warn('[ND PDF] svgToPngDataUrl failed', e);
    return null;
  }
}

async function collectInlineSvgDrawings(rowEl, targetPx) {
  if (!rowEl) return [];

  const raw = Array.from(rowEl.querySelectorAll(
    '[data-nd-pdf-drawing="1"], [data-nd-cart-drawing="1"], svg.nd-pdf-drawing, svg.nd-cart-drawing, .nd-pdf-drawing svg, .nd-cart-drawing svg, svg'
  ));

  const svgs = [];
  raw.forEach(el => {
    if (!el) return;

    if (String(el.tagName || '').toLowerCase() === 'svg') {
      svgs.push(el);
    } else {
      svgs.push(...Array.from(el.querySelectorAll('svg')));
    }
  });

  const unique = Array.from(new Set(svgs)).filter(isLikelyPdfDrawingSvg);

  const out = [];
  for (const svg of unique) {
    const item = await svgToPngDataUrl(svg, targetPx);
    if (item) out.push(item);
    if (out.length >= MAX_IMAGES_PER_ITEM) break;
  }

  return out;
}

  function collectImageUrls(it, domPairs, rowEl) {
    const urls = [];

    // 1. 舊站 NDIMG 邏輯，若新站也有載入就沿用
    try {
      if (ND && typeof ND.getItemImageUrls === 'function') {
        const oldUrls = ND.getItemImageUrls(it, domPairs, rowEl);
        if (Array.isArray(oldUrls)) urls.push(...oldUrls);
      }
    } catch (e) {
      console.warn('[ND PDF] NDIMG.getItemImageUrls failed:', e);
    }

    // 2. 新站 cart row 內實際顯示的圖片
    try {
      if (rowEl) {
        rowEl.querySelectorAll('img').forEach(img => {
          urls.push(
            img.currentSrc,
            img.src,
            img.getAttribute('src'),
            img.getAttribute('data-src'),
            img.getAttribute('data-original'),
            pickFromSrcset(img.getAttribute('srcset')),
            pickFromSrcset(img.getAttribute('data-srcset'))
          );
        });
      }
    } catch (e) {
      console.warn('[ND PDF] cart row image scan failed:', e);
    }

    // 3. Shopify /cart.js 裡面的圖片欄位
    try {
      urls.push(
        it?.image,
        it?.featured_image?.url,
        it?.featured_image,
        it?.variant_image
      );
    } catch (_) {}

    // 4. 若圖片 URL 被存在 properties，也一起抓
    try {
      const props = it?.properties || {};
      Object.keys(props || {}).forEach(k => {
        const v = props[k];
        if (
          /(image|img|drawing|picture|photo|png|jpg|jpeg|webp)/i.test(k) ||
          /\.(png|jpe?g|webp)(\?|$)/i.test(String(v || ''))
        ) {
          urls.push(v);
        }
      });
    } catch (_) {}

    const cleaned = urls
  .map(x => String(x || '').trim())
  .filter(Boolean)
  .filter(u =>
    /^data:image\//i.test(u) ||
    /^(https?:)?\/\//i.test(u) ||
    u.startsWith('/')
  );

// 重要：不能只用 Set，因為 Shopify 同一張圖會有不同 width/query
return uniqueImageUrls(cleaned);
  }

  async function urlToDataUrlFallback(url, targetPx) {
    url = normalizeShopifyImgUrl(url, targetPx);
    if (!url) return null;

    if (/^data:image\//i.test(url)) return url;

    // 舊站 helper 若存在，優先使用
    try {
      if (ND && typeof ND.urlToBase64PNG === 'function') {
        const b64 = await ND.urlToBase64PNG(url, targetPx);
        if (b64) return 'data:image/png;base64,' + b64;
      }
    } catch (e) {
      console.warn('[ND PDF] NDIMG.urlToBase64PNG failed, fallback fetch:', url, e);
    }

    // 新站 fallback：直接 fetch 圖片轉 dataURL
    try {
      const resp = await fetch(url, {
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'omit'
      });

      if (!resp.ok) throw new Error('image fetch failed: ' + resp.status);

      const blob = await resp.blob();

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.warn('[ND PDF] image fetch failed:', url, e);
      return null;
    }
  }

  for (let i = 0; i < (cart.items || []).length; i++) {
    const it = cart.items[i];
    const rowEl = (trs && trs[i]) ? trs[i] : null;
    const domPairs = rowEl ? readPairs(rowEl) : [];

    let urls = collectImageUrls(it, domPairs, rowEl);
    urls = prioritizeUrls(urls);

    const out = [];
const loadedKeys = new Set();

// ★ v5 重點：如果 line 裡有 inline SVG drawing，就只用 SVG 轉出的 PNG。
// 不再混入 cart <img> thumbnail，避免寬版門被縮圖裁切、比例錯誤、或被 swap2 換成小圖。
let hasInlineSvgDrawing = false;
try {
  const svgImgs = await collectInlineSvgDrawings(
    rowEl,
    Math.round(1400 * FETCH_OVERSCALE)
  );

  if (svgImgs && svgImgs.length) {
    hasInlineSvgDrawing = true;
    svgImgs.slice(0, 1).forEach(im => {
      if (out.length < MAX_IMAGES_PER_ITEM) out.push(im);
    });
  }
} catch (e) {
  console.warn('[ND PDF] collectInlineSvgDrawings failed:', e);
}

// 只有在沒有 inline SVG drawing 時，才退回舊的 URL / img 抓圖流程。
if (!hasInlineSvgDrawing) {
for (const rawUrl of urls) {
  if (out.length >= MAX_IMAGES_PER_ITEM) break;

  const imgKey = canonicalImageKey(rawUrl);
  if (imgKey && loadedKeys.has(imgKey)) continue;
      const suggestedLandscape = /need_drawing|^.*\/DGT/i.test(rawUrl);
      const basePtW = suggestedLandscape ? BASE_LAND_W : BASE_PORT_W;

      const pb = panelBonus(rawUrl);
      const bonusW = (isTransomUrl(rawUrl) ? TRANSOM_W_BONUS : 0) + pb.w;
      const targetPtW = (basePtW + bonusW) * IMG_SCALE;
      const targetPx = Math.round(ptToPx(targetPtW) * FETCH_OVERSCALE);

      const du = await urlToDataUrlFallback(rawUrl, targetPx);

      if (du) {
  if (imgKey) loadedKeys.add(imgKey);

  out.push({
          dataUrl: du,
          isLandscape: suggestedLandscape || isTransomUrl(rawUrl) || isThreePanel(rawUrl) || isFourPanel(rawUrl),
          isPattern: /(need_drawing|_equal_lite|_4_lite_tall|_9_lite_prairie)/i.test(rawUrl),
          url: rawUrl
        });

        if (out.length >= MAX_IMAGES_PER_ITEM) break;
      }
    }
}

    console.log('[ND PDF] image urls line', i + 1, urls, 'loaded:', out.length);

    if (out.length) map[i + 1] = out;
  }

  console.log('[ND PDF] final image map:', map);
  return map;
}

  // 右側區塊 X/W/Y
  function getRightBlockXYW(data) {
    const cellUnit = data.row.cells['5'];
    const cellLine = data.row.cells['6'];
    if (!cellUnit || !cellLine) return null;
    const x = cellUnit.x + RCOL_PAD;
    const w = (cellLine.x + cellLine.width) - cellUnit.x - (RCOL_PAD * 2);
    const y = cellUnit.y;
    return { x, w, y, page: data.pageNumber };
  }

  /* ---------- 主流程：產 PDF ---------- */
  async function exportPDF() {
    const cart = await fetchCart();
    if (!cart?.items?.length) { alert('Cart is empty'); return; }

    // ★★ Quote #：優先使用 GAS 回傳的正式編號；
    //     如果目前還沒有，也照樣匯出 PDF，只是用 DRAFT-日期 當作編號顯示（不再本機跑號）。
    const officialNo = getOfficialQuoteNo();

    let fileQuoteNo;
    let serialShort;
    let prefix = 'DRAFT';

    if (officialNo) {
      fileQuoteNo = officialNo;
      serialShort = officialNo;
      prefix = officialNo.split('-')[0];
    } else {
      const today = fmtMDY();
      fileQuoteNo = `DRAFT-${today}`;
      serialShort = fileQuoteNo;
    }

    await ensurePdfLibs();
const { jsPDF } = window.jspdf;
const doc = new jsPDF({ unit: 'pt', format: 'a4', compress: true });

const COMPANY = 'MP Doors';

const SHOPIFY_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0738/1503/2037/files/72a7c97e-4b26-4f68-a5d4-7c2a5e3ed174.png?v=1774620628';

let BRAND_LOGO_DATA_URL = '';
try {
  BRAND_LOGO_DATA_URL = await urlToDataUrl(SHOPIFY_LOGO_URL);
} catch (e) {
  console.warn('[ND PDF] logo load failed', e);
}

const margin = { top: 72, right: 36, bottom: 60, left: 36 };
    const pageW = doc.internal.pageSize.getWidth();
    const contentW = pageW - margin.left - margin.right;

    const dateStr = fmtMDY();

    const attrs = (cart && cart.attributes) || {};
    const shipDom = readShippingInfoFromDOM();

    const shipContact = pickAttr(attrs, shipDom.contact,
      ['Shipping Contact Name', 'Contact Name', 'contact_name', 'contact']);
    const shipPhone = pickAttr(attrs, shipDom.phone,
      ['Shipping Phone', 'Phone Number', 'phone_number', 'Phone', 'phone']);
    const shipCompany = pickAttr(attrs, shipDom.company,
      ['Company Name', 'company_name', 'Company']);
    const shipAddress = pickAttr(attrs, shipDom.address,
  ['Shipping Address', 'shipping_address', 'Address']);

const shipState = pickAttr(attrs, shipDom.state,
  ['Shipping State', 'shipping_state', 'State']);

const shippingLines = [];
if (shipContact) shippingLines.push('Contact Name : ' + shipContact);
if (shipCompany) shippingLines.push('Company Name : ' + shipCompany);
if (shipAddress) shippingLines.push('Address : ' + shipAddress);
if (shipState) shippingLines.push('State : ' + shipState);
if (shipPhone) shippingLines.push('Phone : ' + shipPhone);

// Ship To layout: compact and collision-safe.
// Normal quotations keep the existing table position. If company/address text
// wraps to extra lines, the first-page product table is pushed down automatically.
const SHIP_BLOCK_START_Y = 64;
const SHIP_TITLE_FONT_SIZE = 9.5;
const SHIP_TEXT_FONT_SIZE = 8.5;
const SHIP_TITLE_GAP = 11;
const SHIP_LINE_HEIGHT = 10.5;
const SHIP_MAX_WIDTH = 360;

doc.setFont('helvetica', 'normal');
doc.setFontSize(SHIP_TEXT_FONT_SIZE);

const shipRenderedLineCount = shippingLines.reduce((count, line) => {
  const wrapped = doc.splitTextToSize(String(line || ''), SHIP_MAX_WIDTH);
  return count + Math.max(1, wrapped.length);
}, 0);

const shipBlockBottomY = shippingLines.length
  ? SHIP_BLOCK_START_Y + SHIP_TITLE_GAP + (shipRenderedLineCount * SHIP_LINE_HEIGHT)
  : 0;

const FIRST_PAGE_TABLE_START_Y = Math.max(
  170,
  shippingLines.length ? shipBlockBottomY + 12 : 170
);

    const refDOM = readReferenceFallbackFromDOM();
    const refAttr = pickAttr(attrs, '', ['Reference Number', 'reference_number', 'Reference']);
    const refRaw = (refDOM || refAttr || '').trim();
    const refShort = refRaw ? refRaw.slice(0, 120) : '';

    const specialDom = readSpecialInstructionFromDOM();
    const specialJson = (cart && typeof cart.note === 'string') ? cart.note.trim() : '';
    const specialRaw = (specialDom || specialJson || '').trim();

    const FACTOR = readLiveFactor();
    const amountDiscountCents = readAmountDiscountFromDOM();
    const hasVolumeDiscount = Number.isFinite(amountDiscountCents) && amountDiscountCents > 0;
    const deliveryMethodLabel = readDeliveryMethodLabel(cart);
    window.__ND_FACTOR_EFFECTIVE__ = FACTOR;
    try { localStorage.setItem(FACTOR_KEY, String(FACTOR)); } catch (_) { }

    const head = [['Line', 'Product', 'Option Value', 'Quantity', 'Add-on Price', 'Unit price', 'Line price']];
    const body = []; const trs = domRows(); const preImageMap = await buildImageMap(cart, trs);

    (cart.items || []).forEach((it, idx) => {
      const seen = new Set(); const detailRows = []; let optIdx = 0;

      const feed = (label, raw) => {
        const lab = String(label || '').trim(); if (!lab) return;

        // ★ PATCH: Hide uuid/_bss/_nd/nd: keys from export (applies to DOM/options/properties)
        if (__ndShouldSkipExportPropKey(lab)) return;

        if (lab.startsWith('_') || /^_+bss/i.test(lab)) return;
        const p = parseAddon(raw);
        if (norm(lab) === 'title' || norm(p.clean) === 'default title') return;
        // Dimension rows are re-added below from the ROYAL/Neuma dimension source.
        // Always suppress raw dimension properties here so Premium never receives them
        // and ROYAL cannot duplicate them.
        if (
          norm(lab) === 'unit dim.' ||
          norm(lab) === 'unit dim' ||
          norm(lab) === 'rough opening' ||
          norm(lab) === 'glass dimension'
        ) return;

        const dispLab = trimDashName(lab);

        const key = `${norm(dispLab)}|${norm(p.clean || raw || '')}`;
        if (seen.has(key)) return;
        seen.add(key);

        let addNum = 0;
        if (p.add) {
          // Add-on Price 顯示用：美元 * factor → 小數兩位
          addNum = Math.round(parseFloat(p.add || '0') * 100 * FACTOR) / 100;
        }
        const addCell = (optIdx === 0)
          ? ''
          : (addNum ? `$${fmtMoney(addNum)}` : '');

        detailRows.push([
          '',
          '· ' + dispLab,
          (p.clean || '').trim(),
          '',
          addCell,
          '',
          ''
        ]);
        optIdx++;
      };

      const rowEl = (trs.length && trs[idx]) ? trs[idx] : null;
      const domPairs = rowEl ? readPairs(rowEl) : null;
      const series = detectSeriesByItemRow(it, rowEl);

      if (series === 'premium') {
  // Premium：顯示配對後產品標題 + 詳細選配條列
  const premiumSummary = getPremiumSummaryText(rowEl, it);
  const summaryText = String(premiumSummary || '').trim();

  if (summaryText) {
    const premiumSummaryRow = [
      { content: '', styles: { minCellHeight: 16 } },
      {
        content: summaryText,
        colSpan: 4,
        styles: {
          halign: 'left',
          valign: 'middle',
          minCellHeight: 16,
          cellPadding: { top: 3, right: 2, bottom: 3, left: 8 },
          fontStyle: 'bold'
        }
      },
      { content: '', styles: { minCellHeight: 16 } },
      { content: '', styles: { minCellHeight: 16 } }
    ];
    premiumSummaryRow.__isPremiumSummary = true;
    detailRows.push(premiumSummaryRow);
  }

  if (domPairs && domPairs.length) {
    domPairs.forEach(([k, v]) => {
      const key = String(k || '').trim();
      const val = String(v || '').trim();

      if (!key || !val) return;
      if (__ndShouldSkipExportPropKey(key)) return;
      if (key.startsWith('_')) return;
      if (/^group_name$/i.test(key)) return;
      if (/^matched product$/i.test(key)) return;

      feed(key, val);
    });
  }
} else if (domPairs && domPairs.length) {
  // Royal：照舊詳列選配
  domPairs.forEach(([k, v]) => feed(k, v));
} else {
  (it.options_with_values || []).forEach(o => {
    if (o) feed(o.name || '', o.value || '');
  });
  const props = it.properties || {};
  if (Array.isArray(props)) {
    props.forEach(p => feed(
      p?.name ?? p?.key ?? '',
      p?.value ?? p?.val ?? p?.last
    ));
  } else if (typeof props === 'object') {
    Object.keys(props).forEach(k => feed(k, props[k]));
  }
}

      function hasDetailLabel(rows, label) {
  const target = String(label || '').toLowerCase().replace(/\s+/g, ' ').trim();
  return (rows || []).some(r => {
    const text = String(r?.[1] || '')
      .replace(/^·\s*/, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
    return text === target;
  });
}

const dimBlock = readDimensionBlockFromCartRow(rowEl);
const seriesForDims = detectSeriesByItemRow(it, rowEl);

// ROYAL only: use the exact Neuma dimension table shared by the cart display.
// The visible cart block remains the first choice so the quotation mirrors what
// the user sees; the shared mapper is the timing-safe fallback for PDF export.
let mappedRoyalDims = {
  unit_dimension: '',
  rough_opening: '',
  glass_dimension: ''
};

if (seriesForDims === 'royal') {
  try {
    if (
      window.ND_ROYAL_DIMENSIONS &&
      typeof window.ND_ROYAL_DIMENSIONS.getFromItem === 'function'
    ) {
      mappedRoyalDims = window.ND_ROYAL_DIMENSIONS.getFromItem(it) || mappedRoyalDims;
    } else {
      // Legacy fallback: Unit Dim. can still be resolved by the older helper.
      mappedRoyalDims.unit_dimension =
        getUnitDimensionFromPairs(domPairs || [], rowEl, it) || '';
    }
  } catch (e) {
    console.warn('[ND PDF] ROYAL dimension mapping failed', e);
  }
}

const unitDim = seriesForDims === 'royal'
  ? (dimBlock.unitDim || mappedRoyalDims.unit_dimension || '')
  : '';

if (unitDim && !hasDetailLabel(detailRows, 'Unit Dim.') && !hasDetailLabel(detailRows, 'Unit Dim')) {
  detailRows.push([
    '',
    '· Unit Dim.',
    unitDim,
    '',
    '',
    '',
    ''
  ]);
}

const roughOpening = seriesForDims === 'royal'
  ? (dimBlock.roughOpening || mappedRoyalDims.rough_opening || '')
  : '';

if (roughOpening && !hasDetailLabel(detailRows, 'Rough Opening')) {
  detailRows.push([
    '',
    '· Rough Opening',
    roughOpening,
    '',
    '',
    '',
    ''
  ]);
}

const glassDimension = seriesForDims === 'royal'
  ? (dimBlock.glassDimension || mappedRoyalDims.glass_dimension || '')
  : '';

if (glassDimension && !hasDetailLabel(detailRows, 'Glass Dimension')) {
  detailRows.push([
    '',
    '· Glass Dimension',
    glassDimension,
    '',
    '',
    '',
    ''
  ]);
}
      const noGlassDeductionCents = getNoGlassDeductionCentsFromPairs(domPairs || [], rowEl);
if (noGlassDeductionCents > 0) {
  const noGlassDisplay = Math.round(noGlassDeductionCents * FACTOR) / 100;

  detailRows.push([
    '',
    '· No Glass Credit',
    'Deduction',
    '',
    `-$${fmtMoney(noGlassDisplay)}`,
    '',
    ''
  ]);
}
      const lineNo = idx + 1;
const title = String(it.product_title || it.title || '');
const qty = it.quantity || 0;

const tr = trs[idx] || null;

let unit = '$0.00';
let lineTotal = '$0.00';

const unitCents = Math.round(Number(it?.final_price ?? it?.price ?? 0));
const lineCents = unitCents * qty;

unit = `$${money2(unitCents)}`;
lineTotal = `$${money2(lineCents)}`;


      const main = [
        { content: String(lineNo), styles: { fontStyle: 'bold' } },
        { content: title, colSpan: 2, styles: { fontStyle: 'bold' } },
        { content: String(qty), styles: { halign: 'center', fontStyle: 'bold' } },
        { content: '', styles: { halign: 'right', fontStyle: 'bold' } },
        { content: unit, styles: { halign: 'center', fontStyle: 'bold' } },
        { content: lineTotal, styles: { halign: 'center', fontStyle: 'bold' } }
      ];
      main.__isMain = true;
      main.__lineNo = lineNo;
      body.push(main);
      detailRows.forEach(r => body.push(r));
    });

    console.log('[ND PDF] building total rows with discount block');

// 你新站的 cart.total_price 目前等同於折扣後金額
const estimatedAfterDiscount = Math.round(Number(cart?.total_price || 0));

// 折扣前金額 = 折扣後金額 + discount
const estimatedTotalCents = estimatedAfterDiscount + amountDiscountCents;


const totalLabelStyle = {
  halign: 'right',
  fontStyle: 'bold',
  lineWidth: { top: 0.2, right: 0.2, bottom: 0.2, left: 0.2 },
  cellPadding: { top: 4, right: 8, bottom: 4, left: 8 }
};

const totalValueStyle = {
  halign: 'right',
  fontStyle: 'bold',
  lineWidth: { top: 0.2, right: 0.2, bottom: 0.2, left: 0.2 },
  cellPadding: { top: 4, right: 8, bottom: 4, left: 8 }
};

const discountLabelStyle = {
  halign: 'right',
  fontStyle: 'bold',
  lineWidth: { top: 0.2, right: 0.2, bottom: 0.8, left: 0.2 },
  cellPadding: { top: 4, right: 8, bottom: 6, left: 8 }
};

const discountValueStyle = {
  halign: 'right',
  fontStyle: 'bold',
  lineWidth: { top: 0.2, right: 0.2, bottom: 0.8, left: 0.2 },
  cellPadding: { top: 4, right: 8, bottom: 6, left: 8 }
};

body.push([
  { content: 'Estimated Total', colSpan: 6, styles: totalLabelStyle },
  { content: `$${money2(estimatedTotalCents)} USD`, styles: totalValueStyle }
]);

// Only show discount-related rows when a real discount was applied.
// Without a discount, the PDF ends with the single Estimated Total row.
if (hasVolumeDiscount) {
  body.push([
    { content: 'Volume Discount', colSpan: 6, styles: discountLabelStyle },
    { content: `-$${money2(amountDiscountCents)} USD`, styles: discountValueStyle }
  ]);

  body.push([
    {
      content: 'Estimated Amount After Discount',
      colSpan: 6,
      styles: totalLabelStyle,
      fontSize: 11
    },
    {
      content: `$${money2(estimatedAfterDiscount)} USD`,
      styles: totalValueStyle,
      fontSize: 11
    }
  ]);
}

const W_LINE = 34;
const W_QTY = 52;
const W_UNIT = 72;
const W_ADD = 78;
const W_LINEPRICE = 98;
const W_VAL = 100;

const fixedSum = W_LINE + W_QTY + W_UNIT + W_ADD + W_LINEPRICE + W_VAL;
const W_PRODUCT = Math.max(60, contentW - fixedSum);

    let currentLineNo = 0;
const rightBlock = {};
const doorAnchor = {};
const lineBottom = {};
const premiumSummaryBottom = {};
const pendingMain = [];
const lastRBPerPage = {};
const imgBottomByPage = {};
const premiumLineNos = new Set();

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.0);
    doc.autoTable({
  startY: FIRST_PAGE_TABLE_START_Y,
  head, body, margin,
      styles: {
        font: 'helvetica',
        fontSize: 9.0,
        cellPadding: 3.0,
        lineColor: [200, 200, 200],
        lineWidth: 0.6,
        overflow: 'linebreak',
        valign: 'top'
      },
      headStyles: {
        fillColor: [246, 246, 246],
        textColor: [20, 20, 20],
        lineColor: [180, 180, 180],
        lineWidth: 1,
        halign: 'center'
      },
      columnStyles: {
        0: { cellWidth: W_LINE, halign: 'center' },
        1: { cellWidth: W_PRODUCT },
        2: { cellWidth: W_VAL },
        3: { cellWidth: W_QTY, halign: 'center' },
        4: { cellWidth: W_ADD, halign: 'right' },
        5: { cellWidth: W_UNIT, halign: 'right', overflow: 'visible' },
        6: { cellWidth: W_LINEPRICE, halign: 'right', overflow: 'visible' }
      },

      didDrawPage: (data) => {
        const y0 = 30, rx = pageW - margin.right;

if (BRAND_LOGO_DATA_URL) {
  try {
    const logoW = 100;
    const logoH = 80;
    const logoY = y0 - 40;

    doc.addImage(
      BRAND_LOGO_DATA_URL,
      'PNG',
      margin.left,
      logoY,
      logoW,
      logoH,
      undefined,
      'FAST'
    );
  } catch (e) {
    console.warn('[ND PDF] brand logo draw failed', e);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(20);
    doc.text(COMPANY, margin.left, y0);
  }
} else {
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.setTextColor(20);
  doc.text(COMPANY, margin.left, y0);
}

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.text(`Quotation # : ${serialShort}`, rx, y0, { align: 'right' });
        doc.text(`Date : ${dateStr}`, rx, y0 + 14, { align: 'right' });
        if (refShort) doc.text(`Reference # : ${refShort}`, rx, y0 + 28, { align: 'right' });

        if (data.pageNumber === 1 && shippingLines.length) {
  let sy = SHIP_BLOCK_START_Y;
  const shipX = margin.left;
  const textX = margin.left + 8;

  doc.setTextColor(20);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(SHIP_TITLE_FONT_SIZE);
  doc.text('Ship To :', shipX, sy);

  sy += SHIP_TITLE_GAP;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(SHIP_TEXT_FONT_SIZE);

  shippingLines.forEach(line => {
    const wrapped = doc.splitTextToSize(String(line || ''), SHIP_MAX_WIDTH);

    wrapped.forEach(wline => {
      doc.text(wline, textX, sy);
      sy += SHIP_LINE_HEIGHT;
    });
  });
}
      },

      didParseCell: (data) => {
  try {
    if (data.section !== 'body') return;

    const colKey = String(data.column.dataKey);
    const isMain = !!((data.row.raw || {}).__isMain);

    const rowText = Object.values(data.row.cells || {})
      .map(cell => {
        const t = Array.isArray(cell.text) ? cell.text.join(' ') : String(cell.text || '');
        return t.trim();
      })
      .join(' ')
      .trim();

    const isTotalRow =
      /^Estimated\s*total/i.test(rowText) ||
      /^Volume\s*Discount/i.test(rowText) ||
      /^Estimated\s*Amount\s*After\s*Discount/i.test(rowText);

    const isPremiumSummaryRow =
  !isMain &&
  !isTotalRow &&
  rowText &&
  !/^·\s*/.test(rowText) &&
  !/^Estimated/i.test(rowText) &&
  !/^Volume Discount/i.test(rowText);

  if (isPremiumSummaryRow && (colKey === '5' || colKey === '6') && currentLineNo) {
  const bottom = data.cell.y + data.cell.height;
  if (!premiumSummaryBottom[currentLineNo] || bottom > premiumSummaryBottom[currentLineNo]) {
    premiumSummaryBottom[currentLineNo] = bottom;
  }
}

if (!isMain && !isTotalRow && (colKey === '5' || colKey === '6')) {
  if (data.cell.styles) {
    if (isPremiumSummaryRow) {
      data.cell.styles.lineWidth = { top: 0, right: 0.6, bottom: 0.6, left: 0.6 };
    } else {
      data.cell.styles.lineWidth = 0;
    }
  }
}
  } catch (_) { }
},


      didDrawCell: (data) => {
        try {
          if (data.section !== 'body') return;
          const colKey = String(data.column.dataKey);
          const isMain = !!((data.row.raw || {}).__isMain);

          if (isMain && colKey === '1') {
            currentLineNo = (data.row.raw.__lineNo || 0);
          }
          if (currentLineNo) {
            const bottom = data.cell.y + data.cell.height;
            if (!lineBottom[currentLineNo] || bottom > lineBottom[currentLineNo]) {
              lineBottom[currentLineNo] = bottom;
            }
          }

          if (colKey === '1' && !isMain && currentLineNo) {
            const txt = (Array.isArray(data.cell.text) ? data.cell.text.join(' ') : String(data.cell.text || '')).trim();
            if (/^·\s*Door\s*Size/i.test(txt)) {
              doorAnchor[currentLineNo] = { page: data.pageNumber, y: data.cell.y };
            }
            return;
          }

          if (isMain && (colKey === '5' || colKey === '6')) {
            const ln = data.row.raw.__lineNo;
            if (!rightBlock[ln]) {
              const rb = getRightBlockXYW(data);
              if (rb) {
                rightBlock[ln] = rb;
                pendingMain.push({ lineNo: ln });
                lastRBPerPage[data.pageNumber] = rb;
              }
            }
          }

          const rowText = Object.values(data.row.cells || {})
  .map(cell => {
    const t = Array.isArray(cell.text) ? cell.text.join(' ') : String(cell.text || '');
    return t.trim();
  })
  .join(' ')
  .trim();

const isTotalRow =
  /^Estimated\s*total/i.test(rowText) ||
  /^Volume\s*Discount/i.test(rowText) ||
  /^Estimated\s*Amount\s*After\s*Discount/i.test(rowText);

const isPremiumSummaryRow =
  !isMain &&
  !isTotalRow &&
  rowText &&
  !/^·\s*/.test(rowText) &&
  !/^Estimated/i.test(rowText) &&
  !/^Volume Discount/i.test(rowText);

if (!isMain && !isTotalRow && (colKey === '5' || colKey === '6')) {
  const x = data.cell.x, y = data.cell.y, w = data.cell.width, h = data.cell.height;
  const g = 200;
  data.doc.setDrawColor(g, g, g);
  data.doc.setLineWidth(0.6);

  if (!isPremiumSummaryRow) {
    data.doc.line(x, y, x, y + h);
    data.doc.line(x + w, y, x + w, y + h);
    return;
  }

  // premium 摘要列：補左右 + 下框線
  data.doc.line(x, y, x, y + h);
  data.doc.line(x + w, y, x + w, y + h);
  data.doc.line(x, y + h, x + w, y + h);
  return;
}

if (isTotalRow && (colKey === '5' || colKey === '6')) {
  const x = data.cell.x, y = data.cell.y, w = data.cell.width, h = data.cell.height;
  const g = 180;
  data.doc.setDrawColor(g, g, g);
  data.doc.setLineWidth(0.6);
  data.doc.rect(x, y, w, h);
  return;
}
        } catch (_) { }
      },

      theme: 'grid',
      pageBreak: 'auto',
      tableWidth: contentW
    });

    function fitIntoBox(srcW, srcH, maxW, maxH) {
      const safeW = Math.max(1, Number(srcW || 1));
      const safeH = Math.max(1, Number(srcH || 1));
      const boxW = Math.max(1, Number(maxW || safeW));
      const boxH = Math.max(1, Number(maxH || safeH));

      // ★ 重要：不要限制 ratio <= 1。
      // 舊版只能縮小，不能放大，所以 PDF 右欄的門圖會超小。
      const ratio = Math.min(boxW / safeW, boxH / safeH);

      return {
        w: Math.max(18, safeW * ratio),
        h: Math.max(18, safeH * ratio)
      };
    }

    function getImageAspect(im) {
      // ★ 最可靠：直接讀 jsPDF 取得的 PNG 實際寬高。
      // 之前會小，是因為有些 cart 圖其實是 <img> 或 dataURL，沒有 isSvgDrawing / url 檔名，
      // 會掉到 0.62 直式預設比例，導致被算成又窄又小。
      try {
        if (im?.dataUrl && doc && typeof doc.getImageProperties === 'function') {
          const props = doc.getImageProperties(im.dataUrl);
          const pw = Number(props?.width || 0);
          const ph = Number(props?.height || 0);
          if (pw > 0 && ph > 0) return pw / ph;
        }
      } catch (e) {
        console.warn('[ND PDF] getImageProperties failed:', e);
      }

      if (im && Number.isFinite(Number(im.aspect)) && Number(im.aspect) > 0) {
        return Number(im.aspect);
      }

      const u = String(im?.url || '');

      if (isTransomUrl(u)) return 3.0;
      if (isFourPanel(u) || /bypass/i.test(u)) return 2.25;
      if (isThreePanel(u)) return 1.75;
      if (im?.isLandscape) return 1.65;

      // ★ 保守改成橫圖預設，不再用 0.62 直式預設。
      // Royal/Gliding/Bypass 的 cart drawing 大多是橫式；就算 single door 也會被 maxH 限制住。
      return 1.45;
    }

    /* ------------------------------------------------------------------
     * PDF 產品圖尺寸調整區（v8 Adjustable）
     * ------------------------------------------------------------------
     * 這裡是你以後最常調的地方。
     * 不同門款可以分開調，不需要再用一個 IMAGE_GLOBAL_SCALE 全部一起縮放。
     *
     * 欄位說明：
     * - widthPct：使用右側圖片區寬度的比例。越大越寬。
     * - heightPct：使用該 line item 可用高度的比例。越大越高。
     * - maxW / maxH：絕對最大寬高，避免小門被放太大。
     * - minW / minH：絕對最小寬高，避免太小看不清。
     * - stretchY：只拉高圖片高度，用來修正看起來太矮胖的圖。
     * - shiftRightPt：該門款額外往右位移，避免蓋到 Add-on / Unit 中間線。
     * - yOffsetPt：該門款額外往下位移。
     *
     * 微調方向：
     * - 小門太大：降低 fixed_1_panel / single_hinged 的 widthPct 或 maxW。
     * - 三扇四扇太小：提高 gliding_3_panel / gliding_4_panel 的 widthPct 或 maxW。
     * - 圖太矮胖：提高該門款 stretchY，例如 1.08 → 1.14。
     * - 圖太高：降低該門款 stretchY 或 heightPct。
     */
    const DOOR_IMAGE_TUNING = {
      fixed_1_panel: {
        widthPct: 0.46,
        heightPct: 0.86,
        maxW: 70,
        maxH: 126,
        minW: 42,
        minH: 58,
        stretchY: 1.14,
        shiftRightPt: 8,
        yOffsetPt: 0
      },

      single_hinged: {
  widthPct: 0.44,
  heightPct: 0.66,
  maxW: 64,
  maxH: 96,
  minW: 40,
  minH: 52,
  stretchY: 0.97,
  shiftRightPt: 0,
  yOffsetPt: 2
},

      gliding_2_panel: {
        widthPct: 0.68,
        heightPct: 0.82,
        maxW: 104,
        maxH: 104,
        minW: 62,
        minH: 46,
        stretchY: 1.07,
        shiftRightPt: 8,
        yOffsetPt: 0
      },

      center_hinged: {
        widthPct: 0.70,
        heightPct: 0.84,
        maxW: 106,
        maxH: 112,
        minW: 62,
        minH: 50,
        stretchY: 1.10,
        shiftRightPt: 8,
        yOffsetPt: 0
      },

      double_hinged: {
        widthPct: 0.72,
        heightPct: 0.82,
        maxW: 110,
        maxH: 108,
        minW: 64,
        minH: 50,
        stretchY: 1.08,
        shiftRightPt: 8,
        yOffsetPt: 0
      },

  gliding_3_panel: {
  widthPct: 1.04,
  heightPct: 0.90,
  maxW: 165,
  maxH: 108,
  minW: 100,
  minH: 48,
  stretchY: 1.10,
  shiftRightPt: 6,
  yOffsetPt: 0
},

gliding_4_panel: {
  widthPct: 1.12,
  heightPct: 0.92,
  maxW: 200,
  maxH: 112,
  minW: 116,
  minH: 48,
  stretchY: 1.10,
  shiftRightPt: 6,
  yOffsetPt: 0
},

bypass_gliding: {
  widthPct: 1.14,
  heightPct: 0.92,
  maxW: 205,
  maxH: 114,
  minW: 118,
  minH: 48,
  stretchY: 1.10,
  shiftRightPt: 6,
  yOffsetPt: 0
},

      transom: {
        widthPct: 0.92,
        heightPct: 0.68,
        maxW: 138,
        maxH: 52,
        minW: 74,
        minH: 24,
        stretchY: 1.00,
        shiftRightPt: 8,
        yOffsetPt: 0
      },

      default: {
        widthPct: 0.72,
        heightPct: 0.82,
        maxW: 110,
        maxH: 104,
        minW: 58,
        minH: 42,
        stretchY: 1.08,
        shiftRightPt: 8,
        yOffsetPt: 0
      }
    };

    function getDoorImageBucket(title, im) {
      const t = String(title || '').toLowerCase();
      const aspect = Math.max(0.2, Number(im?.aspect || getImageAspect(im) || 1));

      if (/transom/.test(t) || isTransomUrl(im?.url)) return 'transom';

      if (
        /bypass/.test(t) ||
        /gliding\s*door\s*-\s*bypass/.test(t)
      ) return 'bypass_gliding';

      if (
        /gliding\s*door\s*-\s*4\s*panels/.test(t) ||
        /4\s*panels/.test(t) ||
        /four\s*panels/.test(t) ||
        aspect >= 2.35
      ) return 'gliding_4_panel';

      if (
        /gliding\s*door\s*-\s*3\s*panels/.test(t) ||
        /3\s*panels/.test(t) ||
        /three\s*panels/.test(t) ||
        (aspect >= 1.85 && aspect < 2.35)
      ) return 'gliding_3_panel';

      if (
        /gliding\s*door\s*-\s*2\s*panels/.test(t) ||
        /2\s*panels.*gliding/.test(t) ||
        /gliding.*2\s*panel/.test(t)
      ) return 'gliding_2_panel';

      if (/center\s*hinged/.test(t)) return 'center_hinged';
      if (/double\s*hinged|double\s*door/.test(t)) return 'double_hinged';

      if (
        /fixed\s*-\s*1\s*panel/.test(t) ||
        /fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(t) ||
        /fixed.*1\s*panel/.test(t)
      ) return 'fixed_1_panel';

      if (/single\s*hinged|single\s*door/.test(t)) return 'single_hinged';

      return 'default';
    }

    function getDoorImageTuning(title, im) {
      const bucket = getDoorImageBucket(title, im);
      const base = DOOR_IMAGE_TUNING[bucket] || DOOR_IMAGE_TUNING.default;
      return { ...DOOR_IMAGE_TUNING.default, ...base, bucket };
    }

    function getPdfImageNaturalSize(doc, im) {
      try {
        if (im?.dataUrl && doc && typeof doc.getImageProperties === 'function') {
          const p = doc.getImageProperties(im.dataUrl);
          const w = Number(p?.width || 0);
          const h = Number(p?.height || 0);
          if (w > 0 && h > 0) {
            return { w, h, aspect: w / Math.max(1, h) };
          }
        }
      } catch (e) {
        console.warn('[ND PDF] getPdfImageNaturalSize failed:', e);
      }

      const aspect = Math.max(0.2, Number(im?.aspect || getImageAspect(im) || 1));
      return { w: aspect * 100, h: 100, aspect };
    }

    function fitNaturalSizeToBox(natural, maxW, maxH) {
      const nw = Math.max(1, Number(natural?.w || 1));
      const nh = Math.max(1, Number(natural?.h || 1));
      const bw = Math.max(1, Number(maxW || nw));
      const bh = Math.max(1, Number(maxH || nh));
      const r = Math.min(bw / nw, bh / nh);

      return {
        w: nw * r,
        h: nh * r
      };
    }

    function clampDoorImageSize(s, natural, tune, imgBoxW, remainingH) {
      let w = Math.max(1, Number(s?.w || 1));
      let h = Math.max(1, Number(s?.h || 1));
      const aspect = Math.max(0.2, Number(natural?.aspect || (w / Math.max(1, h)) || 1));

      // 先做高度補正；這是刻意的非等比微調，用來修正 SVG 轉圖後視覺太扁。
      h = h * Number(tune.stretchY || 1);

      // 不可超出目前 line item 可用高度。
      const hardMaxH = Math.max(20, Math.min(Number(tune.maxH || remainingH), remainingH));
      if (h > hardMaxH) {
        const r = hardMaxH / h;
        w *= r;
        h *= r;
      }

      // 不可超出右側圖片區寬度。
      const hardMaxW = Math.max(20, Math.min(Number(tune.maxW || imgBoxW), imgBoxW));
      if (w > hardMaxW) {
        const r = hardMaxW / w;
        w *= r;
        h *= r;
      }

      // 若小於最低值，盡量等比放大，但不能超過可用框。
      const minW = Number(tune.minW || 0);
      const minH = Number(tune.minH || 0);
      const grow = Math.max(
        minW && w < minW ? minW / w : 1,
        minH && h < minH ? minH / h : 1
      );

      if (grow > 1) {
        const maxGrow = Math.min(hardMaxW / w, hardMaxH / h);
        const r = Math.min(grow, maxGrow);
        w *= r;
        h *= r;
      }

      return { w, h, aspect };
    }

    for (const m of pendingMain) {
      const ln = m.lineNo;
      const rawImgs = preImageMap[ln] || [];

      let rb = rightBlock[ln];
      if (!rb) {
        const hintPage = (doorAnchor[ln]?.page) || (rightBlock[ln]?.page) || 1;
        rb = lastRBPerPage[hintPage] || null;
      }
      if (!rawImgs.length || !rb) continue;

      const imgs = reorderImages(rawImgs).slice(0, MAX_IMAGES_PER_ITEM);

      const anchor = doorAnchor[ln];
      let page = (anchor && anchor.page) ? anchor.page : (rb.page || 1);
      doc.setPage(page);

      // ★ v5：只使用 Unit price + Line price 兩欄內部當圖片區。
      // 左邊從 Unit price 欄內縮開始，避免蓋到 Add-on Price / Unit price 中間線；
      // 右邊直接吃到表格右邊界，讓 3/4/Bypass 這類寬版門可以往右展開。
      const tableRightX = pageW - margin.right;
      const unitCellLeftX = rb.x - RCOL_PAD;
      const areaX = Math.max(margin.left, unitCellLeftX + 8);
      const areaW = Math.max(60, tableRightX - areaX - 6);
      // v6：圖片區仍可使用兩欄，但實際圖寬會再乘 IMAGE_GLOBAL_SCALE。
      const imgBoxW = Math.max(54, areaW - 8);
      const IMAGE_SHIFT_RIGHT_PT = 8;

      // ★ 圖片從 Door Size 附近開始，但不要壓到主列價格。
      let y = ((anchor && anchor.y) ? anchor.y : rb.y) + 2;
      y = Math.max(y, (rb.y || 0) + RCOL_TOP_GUARD + 2);

      const pageH = doc.internal.pageSize.getHeight();
      const pageBottom = pageH - margin.bottom;

      let lineBottomLimit =
        (lineBottom[ln] && page === rb.page)
          ? Math.min(lineBottom[ln], pageBottom)
          : pageBottom;

      let usableBottom = lineBottomLimit - 4;

      // ★ 如果這一列真的沒空間，才換到下一頁。
      if ((usableBottom - y) < 40 && page < doc.getNumberOfPages()) {
        page = page + 1;
        doc.setPage(page);
        y = margin.top + RCOL_TOP_GUARD;
        lineBottomLimit = pageBottom;
        usableBottom = lineBottomLimit - 4;
      }

      const totalGap = Math.max(0, imgs.length - 1) * RCOL_GAP_Y;
      const totalAvailableH = Math.max(30, usableBottom - y - totalGap);
      const maxHPerImage = Math.max(30, totalAvailableH / Math.max(1, imgs.length));

      for (let i = 0; i < imgs.length; i++) {
        const im = imgs[i];

        const itemTitle = String(
          cart?.items?.[ln - 1]?.product_title ||
          cart?.items?.[ln - 1]?.title ||
          ''
        );

        const tune = getDoorImageTuning(itemTitle, im);
        const extraDown = (isTransomUrl(im.url) ? TRANSOM_EXTRA_DOWN : 0) + Number(tune.yOffsetPt || 0);

        const remainingImgs = imgs.length - i - 1;
        const reservedGap = remainingImgs * RCOL_GAP_Y;
        const remainingH = Math.max(
          30,
          usableBottom - y - reservedGap - extraDown
        );

        const slotH = Math.max(30, Math.min(maxHPerImage, remainingH));
        const natural = getPdfImageNaturalSize(doc, im);

        const targetW = Math.min(
          imgBoxW * Number(tune.widthPct || 0.72),
          Number(tune.maxW || imgBoxW)
        );

        const targetH = Math.min(
          slotH * Number(tune.heightPct || 0.82),
          Number(tune.maxH || slotH)
        );

        let s = fitNaturalSizeToBox(natural, targetW, targetH);
        s = clampDoorImageSize(s, natural, tune, imgBoxW, remainingH);

        const centeredX = areaX + Math.max(0, (areaW - s.w) / 2);
        const maxX = areaX + areaW - s.w - 2;
        const x = Math.max(
          areaX + 2,
          Math.min(maxX, centeredX + Number(tune.shiftRightPt || 0))
        );
        const drawY = y + extraDown;

        try {
          // ★ 白底先蓋掉 Unit price / Line price 中間那條直線，再把門圖畫上去。
          doc.setFillColor(255, 255, 255);
          doc.rect(
            x - 1,
            drawY - 3,
            s.w + 2,
            s.h + 6,
            'F'
          );

          doc.addImage(
            im.dataUrl,
            'PNG',
            x,
            drawY,
            s.w,
            s.h,
            undefined,
            'FAST'
          );
        } catch (e) {
          console.warn('[ND PDF] product image draw failed:', e);
        }

        const bottom = drawY + s.h;

        if (!imgBottomByPage[page] || bottom > imgBottomByPage[page]) {
          imgBottomByPage[page] = bottom;
        }

        y = bottom + RCOL_GAP_Y;
      }
    }

    // Special Instruction + Disclaimer：最後一頁底部
    {
      let lastPage = doc.getNumberOfPages();
      doc.setPage(lastPage);
      const pageH = doc.internal.pageSize.getHeight();

      const baseAutoY = (doc.lastAutoTable && doc.lastAutoTable.finalY)
        ? doc.lastAutoTable.finalY + 18
        : (margin.top + 18);
      const imgBottom = imgBottomByPage[lastPage] ? imgBottomByPage[lastPage] + 16 : 0;
      let y = Math.max(baseAutoY, imgBottom || 0);
      y += 8;

      // 預留多一點空間給 Special Instruction + Delivery Method + disclaimer
      if (y > pageH - margin.bottom - 80) {
        doc.addPage();
        lastPage = doc.getNumberOfPages();
        doc.setPage(lastPage);
        y = margin.top;
      }

      const maxW = pageW - margin.left - margin.right;

      if (specialRaw) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.text('Special Instruction :', margin.left, y);
        doc.setFont('helvetica', 'normal');

        const lines = doc.splitTextToSize(specialRaw, maxW);
        const lineHeight = 12;
        doc.text(lines, margin.left, y + 14);
        y += 14 + lines.length * lineHeight + 8;
      }

      // Delivery Method：移到 Please Note 附近，避免右上角不易察覺
      if (deliveryMethodLabel) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.text('Delivery Method :', margin.left, y);

        const deliveryLabelX =
          margin.left + doc.getTextWidth('Delivery Method :') + 5;

        doc.setFont('helvetica', 'normal');
        doc.text(deliveryMethodLabel, deliveryLabelX, y);
        y += 18;
      }

      // disclaimer 行
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8.5);
      const dLines = doc.splitTextToSize(DISCLAIMER_TEXT, maxW);
      doc.text(dLines, margin.left, y);
    }

    // Add the signed Import ID returned by the existing MPQuote Apps Script.
    // This makes future PDF uploads more reliable without changing delivery logic.
    const importId = String(
      (window.MPQ_LAST_FINAL_QUOTE && window.MPQ_LAST_FINAL_QUOTE.import_id) || ''
    ).trim();

    if (importId) {
      try {
        doc.setProperties({
          title: fileQuoteNo,
          subject: 'MP Doors Quotation',
          keywords: 'MP Doors Import ID ' + importId
        });
      } catch (_) {}

      const totalPages = doc.getNumberOfPages();
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6.5);
        doc.setTextColor(115, 115, 115);
        doc.text('Import ID: ' + importId, margin.left, doc.internal.pageSize.getHeight() - 18);
        doc.setTextColor(0, 0, 0);
      }
    }

    // ★ 檔名：使用正式編號或 DRAFT-日期
    const fileNameBase = fileQuoteNo;
    const fileName = fileNameBase + '.pdf';

    const ab = await doc.output('arraybuffer');
const pdfBlob = new Blob([ab], { type: 'application/pdf' });
const subpath = `${ROOT_FOLDER}/${customerEmail}/${fmtMDY()}`;

if (window.ND_UPLOAD_EMAIL_BRIDGE) {
  window.ND_UPLOAD_EMAIL_BRIDGE.push({
    serial: fileName.replace(/\.pdf$/i, ''),
    customerEmail,
    customerName: '',
    subpath,
    pdfBlob,
    pdfName: fileName
  });
} else {
  try {
    await uploadToCloud(pdfBlob, fileName, subpath, {
      serial: fileName.replace(/\.pdf$/i, ''),
      reference: refShort
    });
  } catch (e) {
    console.warn('[ND-PDF] upload failed:', e?.message || e);
  }
}
console.log('[ND PDF] about to save pdf:', fileName);
console.log('[ND PDF] total rows marker A');
console.log('[ND PDF] estimatedTotalCents =', estimatedTotalCents);
console.log('[ND PDF] amountDiscountCents =', amountDiscountCents);
console.log('[ND PDF] hasVolumeDiscount =', hasVolumeDiscount);
console.log('[ND PDF] estimatedAfterDiscount =', estimatedAfterDiscount);
console.log('[ND PDF] about to save pdf:', fileName);
doc.save(fileName);
  }

    async function onClick(ev) {
    console.log('[ND PDF] onClick entered');
    const b = ev?.currentTarget || document.getElementById('nd-btn-export');

    try { if (b) b.disabled = true; } catch (_) {}

    try {
      await exportPDF();
    } catch (e) {
      console.error('[PDF export]', e);
      alert('PDF 產生失敗：' + (e?.message || e));
      throw e;
    } finally {
      try { if (b) b.disabled = false; } catch (_) {}
    }
  }

  let __ndExportBtnRunId = 0;

async function withExportButtonState(runExport) {
  const btn = document.getElementById('nd-btn-export');
  const originalText = btn ? (btn.textContent || 'Export Your Quote') : '';
  const originalDisabled = btn ? btn.disabled : false;
  const runId = ++__ndExportBtnRunId;

  try {
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Exporting...';
      btn.style.opacity = '0.7';
      btn.style.cursor = 'wait';
    }

    return await runExport();
  } finally {
    // 只有最後一次執行的流程可以恢復按鈕，避免多重呼叫互相覆蓋
    if (btn && runId === __ndExportBtnRunId) {
      btn.textContent = originalText || 'Export Your Quote';
      btn.disabled = originalDisabled;
      btn.style.opacity = '';
      btn.style.cursor = '';
    }
  }
}
  /* =========================
     NEW SITE DIRECT EXPORT BIND
  ========================= */

  function bindDirectExportButton() {
  const oldBtn = document.getElementById('nd-btn-export');
  if (!oldBtn) {
    console.warn('[ND PDF] export button #nd-btn-export not found');
    return;
  }

  if (oldBtn.dataset.ndPdfBound === '1') return;

  const btn = oldBtn.cloneNode(true);
  btn.dataset.ndPdfBound = '1';
  oldBtn.replaceWith(btn);

  btn.addEventListener('click', async function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      console.log('[ND PDF] export button clicked');
      await withExportButtonState(() => exportPDF());
    } catch (err) {
      console.error('[ND PDF] export failed:', err);
      alert('PDF 匯出失敗，請打開 Console 看錯誤訊息。');
    }
  });

  console.log('[ND PDF] rebound clean handler to #nd-btn-export');
}

//if (document.readyState === 'loading') {
 // document.addEventListener('DOMContentLoaded', bindDirectExportButton);
//} else {
//  bindDirectExportButton();
//  }

//  setTimeout(bindDirectExportButton, 500);
//  setTimeout(bindDirectExportButton, 1500);

  window.__MPQ_exportPDF = async function () {
  console.log('[ND PDF] __MPQ_exportPDF called');

  const btn = document.getElementById('nd-btn-export');
  const originalText = btn ? (btn.textContent || 'Export Your Quote') : '';
  const originalDisabled = btn ? btn.disabled : false;

  try {
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Exporting...';
      btn.style.opacity = '0.7';
      btn.style.cursor = 'wait';
    }

    return await exportPDF();
  } catch (e) {
    console.error('[ND PDF] __MPQ_exportPDF failed:', e);
    throw e;
  } finally {
    if (btn) {
      btn.textContent = originalText || 'Export Your Quote';
      btn.disabled = originalDisabled;
      btn.style.opacity = '';
      btn.style.cursor = '';
    }
  }
};

window.MPQ_EXPORT_PDF = async function () {
  console.log('[ND PDF] MPQ_EXPORT_PDF called');

  const btn = document.getElementById('nd-btn-export');
  const originalText = btn ? (btn.textContent || 'Export Your Quote') : '';
  const originalDisabled = btn ? btn.disabled : false;

  try {
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Exporting...';
      btn.style.opacity = '0.7';
      btn.style.cursor = 'wait';
    }

    return await exportPDF();
  } catch (e) {
    console.error('[ND PDF] MPQ_EXPORT_PDF failed:', e);
    throw e;
  } finally {
    if (btn) {
      btn.textContent = originalText || 'Export Your Quote';
      btn.disabled = originalDisabled;
      btn.style.opacity = '';
      btn.style.cursor = '';
    }
  }
};
})();
